import color from 'assets/scss/_themes-vars.module.scss';

export const AgentsIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="27" height="24" viewBox="0 0 27 24" fill="none">
        <path
            opacity="0.3"
            d="M12.2816 10C13.4544 10 14.4052 9.10457 14.4052 8C14.4052 6.89543 13.4544 6 12.2816 6C11.1087 6 10.158 6.89543 10.158 8C10.158 9.10457 11.1087 10 12.2816 10Z"
            fill={color.grey550}
        />
        <path
            opacity="0.3"
            d="M5.91071 18.0001H11.2092L10.158 17.0001L11.1454 16.0601C8.61833 16.3301 6.12307 17.3701 5.91071 18.0001Z"
            fill={color.grey550}
        />
        <path
            d="M12.2816 12C14.6282 12 16.5288 10.21 16.5288 8C16.5288 5.79 14.6282 4 12.2816 4C9.93498 4 8.03433 5.79 8.03433 8C8.03433 10.21 9.93498 12 12.2816 12ZM12.2816 6C13.4496 6 14.4052 6.9 14.4052 8C14.4052 9.1 13.4496 10 12.2816 10C11.1136 10 10.158 9.1 10.158 8C10.158 6.9 11.1136 6 12.2816 6ZM11.2198 18H5.91071C6.12307 17.37 8.61833 16.33 11.1454 16.06H11.1773L11.6657 15.61L13.3434 14.06C12.9293 14.02 12.6214 14 12.2816 14C9.44654 14 3.78708 15.34 3.78708 18V20H13.3434L11.2198 18ZM22.475 12.5L17.0279 17.67L14.8299 15.59L13.3434 17L17.0279 20.5L23.9615 13.91L22.475 12.5Z"
            fill={color.primaryLight}
        />
    </svg>
);

export const DocumentsIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="27" height="24" viewBox="0 0 27 24" fill="none">
        <path
            opacity="0.3"
            d="M8.76964 16H21.7472V4H8.76964V16ZM10.9326 6H19.5842V8H10.9326V6ZM10.9326 9H19.5842V11H10.9326V9ZM10.9326 12H15.2584V14H10.9326V12Z"
            fill={color.primaryMain}
        />
        <path
            d="M4.44379 22H19.5842V20H4.44379V6H2.28087V20C2.28087 21.1 3.25419 22 4.44379 22ZM6.60672 4V16C6.60672 17.1 7.58003 18 8.76964 18H21.7472C22.9368 18 23.9101 17.1 23.9101 16V4C23.9101 2.9 22.9368 2 21.7472 2H8.76964C7.58003 2 6.60672 2.9 6.60672 4ZM21.7472 16H8.76964V4H21.7472V16ZM10.9326 9H19.5842V11H10.9326V9ZM10.9326 12H15.2584V14H10.9326V12ZM10.9326 6H19.5842V8H10.9326V6Z"
            fill="white"
        />
    </svg>
);

export const GoogleIcon = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.0613 18.2253L9.31871 20.9975L6.60458 21.0549C5.79346 19.5504 5.33337 17.8292 5.33337 16C5.33337 14.2312 5.76354 12.5632 6.52604 11.0945H6.52662L8.94296 11.5375L10.0015 13.9393C9.77992 14.5852 9.65917 15.2785 9.65917 16C9.65925 16.783 9.80108 17.5332 10.0613 18.2253Z"
            fill="#FBBB00"
        />
        <path
            d="M26.4804 14.0073C26.6029 14.6526 26.6668 15.3189 26.6668 16C26.6668 16.7637 26.5865 17.5086 26.4335 18.2271C25.9143 20.6722 24.5575 22.8073 22.678 24.3182L22.6774 24.3177L19.6339 24.1624L19.2031 21.4734C20.4503 20.742 21.425 19.5974 21.9384 18.2271H16.2346V14.0073H22.0216H26.4804Z"
            fill="#518EF8"
        />
        <path
            d="M22.6772 24.3176L22.6777 24.3182C20.8498 25.7875 18.5277 26.6666 16 26.6666C11.9378 26.6666 8.40612 24.3962 6.60449 21.0549L10.0612 18.2253C10.962 20.6294 13.2811 22.3408 16 22.3408C17.1686 22.3408 18.2634 22.0249 19.2029 21.4734L22.6772 24.3176Z"
            fill="#28B446"
        />
        <path
            d="M22.8085 7.78892L19.353 10.6179C18.3807 10.0102 17.2313 9.65909 16 9.65909C13.2196 9.65909 10.8571 11.449 10.0015 13.9393L6.52658 11.0944H6.526C8.30125 7.67171 11.8775 5.33325 16 5.33325C18.5881 5.33325 20.9612 6.25517 22.8085 7.78892Z"
            fill="#F14336"
        />
    </svg>
);

export const AgentsTabIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            opacity="0.3"
            d="M11 10C12.1046 10 13 9.10457 13 8C13 6.89543 12.1046 6 11 6C9.89543 6 9 6.89543 9 8C9 9.10457 9.89543 10 11 10Z"
            fill={color.grey550}
        />
        <path
            opacity="0.3"
            d="M8.46096 16.8339L8.29653 17.0001L8.64467 17.3518L8.79142 17.5H6.50826C6.61183 17.4525 6.72154 17.405 6.83692 17.3577C7.31256 17.163 7.8683 16.9805 8.46096 16.8339Z"
            stroke={color.grey550}
        />
        <path
            d="M10.0704 15.2526L10.0699 15.2531L9.73605 15.5796C8.54477 15.7289 7.37296 16.0578 6.45808 16.4323C5.98372 16.6264 5.56467 16.8385 5.24275 17.053C5.08201 17.1601 4.93513 17.2746 4.81568 17.3957C4.70147 17.5115 4.58233 17.6632 4.52344 17.8487L4.31668 18.5H5H9.79289L10.7929 19.5H3.5V18C3.5 17.5186 3.73716 17.06 4.21364 16.6202C4.69352 16.1773 5.38208 15.7882 6.18469 15.4666C7.72306 14.8504 9.56494 14.5278 10.8357 14.5017L10.0704 15.2526ZM15.8249 18.0222L20.6001 13.2098L21.2958 13.9104L15.4699 19.7897L12.7043 17.0003L13.4004 16.2992L15.1156 18.0227L15.4705 18.3793L15.8249 18.0222ZM14.5 8C14.5 9.93386 12.9339 11.5 11 11.5C9.06614 11.5 7.5 9.93386 7.5 8C7.5 6.06614 9.06614 4.5 11 4.5C12.9339 4.5 14.5 6.06614 14.5 8ZM13.5 8C13.5 6.62386 12.3761 5.5 11 5.5C9.62386 5.5 8.5 6.62386 8.5 8C8.5 9.37614 9.62386 10.5 11 10.5C12.3761 10.5 13.5 9.37614 13.5 8Z"
            fill={color.grey550}
            stroke={color.grey550}
        />
    </svg>
);

export const DashboardTabIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clipPath="url(#clip0_1434_350)">
            <path
                opacity="0.3"
                d="M5.5 5.49999H8.5V8.49999H5.5V5.49999ZM15.5 15.5H18.5V18.5H15.5V15.5ZM5.5 15.5H8.5V18.5H5.5V15.5ZM18.7823 7.34062L16.66 9.46288L14.5377 7.34062L16.66 5.22585L18.7823 7.34062Z"
                stroke={color.grey550}
            />
            <path
                d="M21.6126 7.34032L16.66 12.2929L11.7074 7.34032L16.66 2.39649L21.6126 7.34032ZM16.4529 13.5L16.66 13.7071L16.8671 13.5H20.5V20.5H13.5V13.5H16.4529ZM10.5 7.13264L10.2926 7.33969L10.5 7.54711V10.5H3.5V3.5H10.5V7.13264ZM13.4764 6.98645L13.1229 7.34L13.4764 7.69356L16.3064 10.5236L16.66 10.8771L17.0136 10.5236L19.8436 7.69356L20.1971 7.34L19.8436 6.98645L17.0136 4.15645L16.66 3.8029L16.3064 4.15645L13.4764 6.98645ZM9 9.5H9.5V9V5V4.5H9H5H4.5V5V9V9.5H5H9ZM5 14.5H4.5V15V19V19.5H5H9H9.5V19V15V14.5H9H5ZM19 19.5H19.5V19V15V14.5H19H15H14.5V15V19V19.5H15H19ZM10.5 13.5V20.5H3.5V13.5H10.5Z"
                fill={color.grey550}
                stroke={color.grey550}
            />
        </g>
        <defs>
            <clipPath id="clip0_1434_350">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const PropertiesTabIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clipPath="url(#clip0_1434_357)">
            <path
                opacity="0.3"
                d="M14.5 11V10.5H14H12.5V9.5H19.5V18.5H12.5V17.5H14H14.5V17V15V14.5H14H12.5V13.5H14H14.5V13V11ZM16 10.5H15.5V11V13V13.5H16H18H18.5V13V11V10.5H18H16ZM16 14.5H15.5V15V17V17.5H16H18H18.5V17V15V14.5H18H16Z"
                fill="white"
                stroke={color.grey550}
            />
            <path
                d="M11.5 7V7.5H12H21.5V20.5H2.5V3.5H11.5V7ZM6 19.5H6.5V19V17V16.5H6H4H3.5V17V19V19.5H4H6ZM6 15.5H6.5V15V13V12.5H6H4H3.5V13V15V15.5H4H6ZM6 11.5H6.5V11V9V8.5H6H4H3.5V9V11V11.5H4H6ZM6 7.5H6.5V7V5V4.5H6H4H3.5V5V7V7.5H4H6ZM10 19.5H10.5V19V17V16.5H10H8H7.5V17V19V19.5H8H10ZM10 15.5H10.5V15V13V12.5H10H8H7.5V13V15V15.5H8H10ZM10 11.5H10.5V11V9V8.5H10H8H7.5V9V11V11.5H8H10ZM10 7.5H10.5V7V5V4.5H10H8H7.5V5V7V7.5H8H10ZM20 19.5H20.5V19V9V8.5H20H12H11.5V9V11V11.5H12H13.5V12.5H12H11.5V13V15V15.5H12H13.5V16.5H12H11.5V17V19V19.5H12H20ZM16.5 11.5H17.5V12.5H16.5V11.5ZM16.5 15.5H17.5V16.5H16.5V15.5Z"
                fill={color.grey550}
                stroke={color.grey550}
            />
        </g>
        <defs>
            <clipPath id="clip0_1434_357">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const ClientsTabIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            d="M12.3 12.22C12.8336 11.7581 13.2616 11.1869 13.5549 10.545C13.8482 9.90316 14 9.20571 14 8.5C14 7.17392 13.4732 5.90215 12.5355 4.96447C11.5979 4.02678 10.3261 3.5 9 3.5C7.67392 3.5 6.40215 4.02678 5.46447 4.96447C4.52678 5.90215 4 7.17392 4 8.5C3.99999 9.20571 4.1518 9.90316 4.44513 10.545C4.73845 11.1869 5.16642 11.7581 5.7 12.22C4.30014 12.8539 3.11247 13.8775 2.27898 15.1685C1.4455 16.4596 1.00147 17.9633 1 19.5C1 19.7652 1.10536 20.0196 1.29289 20.2071C1.48043 20.3946 1.73478 20.5 2 20.5C2.26522 20.5 2.51957 20.3946 2.70711 20.2071C2.89464 20.0196 3 19.7652 3 19.5C3 17.9087 3.63214 16.3826 4.75736 15.2574C5.88258 14.1321 7.4087 13.5 9 13.5C10.5913 13.5 12.1174 14.1321 13.2426 15.2574C14.3679 16.3826 15 17.9087 15 19.5C15 19.7652 15.1054 20.0196 15.2929 20.2071C15.4804 20.3946 15.7348 20.5 16 20.5C16.2652 20.5 16.5196 20.3946 16.7071 20.2071C16.8946 20.0196 17 19.7652 17 19.5C16.9985 17.9633 16.5545 16.4596 15.721 15.1685C14.8875 13.8775 13.6999 12.8539 12.3 12.22ZM9 11.5C8.40666 11.5 7.82664 11.3241 7.33329 10.9944C6.83994 10.6648 6.45542 10.1962 6.22836 9.64805C6.0013 9.09987 5.94189 8.49667 6.05764 7.91473C6.1734 7.33279 6.45912 6.79824 6.87868 6.37868C7.29824 5.95912 7.83279 5.6734 8.41473 5.55764C8.99667 5.44189 9.59987 5.5013 10.1481 5.72836C10.6962 5.95542 11.1648 6.33994 11.4944 6.83329C11.8241 7.32664 12 7.90666 12 8.5C12 9.29565 11.6839 10.0587 11.1213 10.6213C10.5587 11.1839 9.79565 11.5 9 11.5ZM18.74 11.82C19.38 11.0993 19.798 10.2091 19.9438 9.25634C20.0896 8.30362 19.9569 7.32907 19.5618 6.45C19.1666 5.57093 18.5258 4.8248 17.7165 4.30142C16.9071 3.77805 15.9638 3.49974 15 3.5C14.7348 3.5 14.4804 3.60536 14.2929 3.79289C14.1054 3.98043 14 4.23478 14 4.5C14 4.76522 14.1054 5.01957 14.2929 5.20711C14.4804 5.39464 14.7348 5.5 15 5.5C15.7956 5.5 16.5587 5.81607 17.1213 6.37868C17.6839 6.94129 18 7.70435 18 8.5C17.9986 9.02524 17.8593 9.5409 17.5961 9.99542C17.3328 10.4499 16.9549 10.8274 16.5 11.09C16.3517 11.1755 16.2279 11.2977 16.1404 11.4447C16.0528 11.5918 16.0045 11.7589 16 11.93C15.9958 12.0998 16.0349 12.2678 16.1137 12.4183C16.1924 12.5687 16.3081 12.6967 16.45 12.79L16.84 13.05L16.97 13.12C18.1754 13.6917 19.1923 14.596 19.901 15.7263C20.6096 16.8566 20.9805 18.1659 20.97 19.5C20.97 19.7652 21.0754 20.0196 21.2629 20.2071C21.4504 20.3946 21.7048 20.5 21.97 20.5C22.2352 20.5 22.4896 20.3946 22.6771 20.2071C22.8646 20.0196 22.97 19.7652 22.97 19.5C22.9782 17.9654 22.5938 16.4543 21.8535 15.1101C21.1131 13.7659 20.0413 12.6333 18.74 11.82Z"
            fill={color.grey550}
        />
    </svg>
);

export const UpdatesTabIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clipPath="url(#clip0_1434_369)">
            <path
                d="M18.5 3V3.5H19H20C20.8239 3.5 21.5 4.17614 21.5 5V21C21.5 21.8239 20.8239 22.5 20 22.5H4C3.17614 22.5 2.5 21.8239 2.5 21V5C2.5 4.17614 3.17614 3.5 4 3.5H5H5.5V3V1.5H6.5V3V3.5H7H17H17.5V3V1.5H18.5V3ZM20.5 5V4.5H20H4H3.5V5V8V8.5H4H20H20.5V8V5ZM3.5 21V21.5H4H20H20.5V21V10V9.5H20H4H3.5V10V21Z"
                stroke={color.grey550}
            />
            <path opacity="0.3" d="M4.5 5.51H19.5V7.5H4.5V5.51Z" fill={color.grey550} stroke={color.grey550} />
        </g>
        <defs>
            <clipPath id="clip0_1434_369">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const DocumentsTabIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clipPath="url(#clip0_1434_376)">
            <path
                opacity="0.3"
                d="M10 5.5H9.5V6V8V8.5V9V11V11.5V12V14V14.5H10H14H14.5V14V12V11.5H18H18.5V11V9V8.5V8V6V5.5H18H10ZM19.5 4.5V15.5H8.5V4.5H19.5Z"
                stroke={color.grey550}
            />
            <path
                d="M4 22H18V20H4V6H2V20C2 21.1 2.9 22 4 22ZM6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2H8C6.9 2 6 2.9 6 4ZM20 16H8V4H20V16ZM10 9H18V11H10V9ZM10 12H14V14H10V12ZM10 6H18V8H10V6Z"
                fill={color.grey550}
            />
        </g>
        <defs>
            <clipPath id="clip0_1434_376">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const FinancialsTabIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clipPath="url(#clip0_1434_383)">
            <path
                opacity="0.3"
                d="M9 17.5H9.5V17V10V9.5H9H7H6.5V10V17V17.5H7H9ZM13 17.5H13.5V17V7V6.5H13H11H10.5V7V17V17.5H11H13ZM17 17.5H17.5V17V13V12.5H17H15H14.5V13V17V17.5H15H17ZM18.5 18.5H5.5V5.5H18.5V18.5Z"
                stroke={color.grey550}
            />
            <path
                d="M19 19.5H19.5V19V5V4.5H19H5H4.5V5V19V19.5H5H19ZM5 3.5H19C19.8239 3.5 20.5 4.17614 20.5 5V19C20.5 19.8239 19.8239 20.5 19 20.5H5C4.17614 20.5 3.5 19.8239 3.5 19V5C3.5 4.17614 4.17614 3.5 5 3.5ZM7.5 10.5H8.5V16.5H7.5V10.5ZM11.5 7.5H12.5V16.5H11.5V7.5ZM15.5 13.5H16.5V16.5H15.5V13.5Z"
                fill={color.grey550}
                stroke={color.grey550}
            />
        </g>
        <defs>
            <clipPath id="clip0_1434_383">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const AgenciesTabIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
        <path
            d="M19.9 5.89L18.85 1.52C18.63 0.62 17.85 0 16.94 0H14.73H12.72H11H9.00001H7.28001H5.26001H3.05001C2.15001 0 1.36001 0.63 1.15001 1.52L0.100007 5.89C-0.139993 6.91 0.0800067 7.95 0.720007 8.77C0.800007 8.88 0.910007 8.96 1.00001 9.06V16C1.00001 17.1 1.90001 18 3.00001 18H17C18.1 18 19 17.1 19 16V9.06C19.09 8.97 19.2 8.88 19.28 8.78C19.92 7.96 20.15 6.91 19.9 5.89ZM5.02001 2L4.44001 6.86C4.36001 7.51 3.84001 8 3.23001 8C2.74001 8 2.43001 7.71 2.30001 7.53C2.04001 7.2 1.95001 6.77 2.05001 6.36L3.05001 2H5.02001ZM16.91 1.99L17.96 6.36C18.06 6.78 17.97 7.2 17.71 7.53C17.57 7.71 17.27 8 16.77 8C16.16 8 15.63 7.51 15.56 6.86L14.98 2L16.91 1.99ZM13.51 6.52C13.56 6.91 13.44 7.3 13.18 7.59C12.95 7.85 12.63 8 12.22 8C11.55 8 11 7.41 11 6.69V2H12.96L13.51 6.52ZM9.00001 6.69C9.00001 7.41 8.45001 8 7.71001 8C7.37001 8 7.06001 7.85 6.82001 7.59C6.57001 7.3 6.45001 6.91 6.49001 6.52L7.04001 2H9.00001V6.69ZM16 16H4.00001C3.45001 16 3.00001 15.55 3.00001 15V9.97C3.08001 9.98 3.15001 10 3.23001 10C4.10001 10 4.89001 9.64 5.47001 9.05C6.07001 9.65 6.87001 10 7.78001 10C8.65001 10 9.43001 9.64 10.01 9.07C10.6 9.64 11.4 10 12.3 10C13.14 10 13.94 9.65 14.54 9.05C15.12 9.64 15.91 10 16.78 10C16.86 10 16.93 9.98 17.01 9.97V15C17 15.55 16.55 16 16 16Z"
            fill={color.primaryDark}
        />
    </svg>
);

export const ArchEngTabIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clip-path="url(#clip0_2941_1799)">
            <path opacity="0.3" d="M16.9262 9.00003L12 12.8363L7.07379 9.00003L12 5.16376L16.9262 9.00003Z" stroke={color.grey550} />
            <path
                d="M11.6831 18.9347L11.9901 19.1734L12.297 18.9347L19.3697 13.4336L20.186 14.0697L12 20.4366L3.81441 14.07L4.62006 13.4434L11.6831 18.9347ZM19.0539 9.87468L19.0528 9.87547L11.9998 15.3665L4.93731 9.87559L4.9369 9.87527L3.81397 9.00035L12 2.63343L20.1845 8.99914L19.0539 9.87468ZM11.6928 13.8645L12 14.1037L12.3072 13.8645L18.0472 9.39449L18.5538 9L18.0472 8.60551L12.3072 4.13551L12 3.89627L11.6928 4.13551L5.95279 8.60551L5.44622 9L5.95279 9.39449L11.6928 13.8645Z"
                fill={color.grey550}
                stroke={color.grey550}
            />
        </g>
        <defs>
            <clipPath id="clip0_2941_1799">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const ManagersTabIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="12" viewBox="0 0 24 12" fill="none">
        <path
            d="M15.2018 8.84423C14.1704 8.44027 13.0884 8.25 12 8.25C10.9119 8.25 9.83018 8.44016 8.79906 8.84388C8.39889 8.99788 8.12248 9.13897 7.93285 9.30863C7.72997 9.49016 7.6568 9.68113 7.61391 9.79309C7.61056 9.80182 7.6074 9.81007 7.60438 9.8178L7.33743 10.5H8.07H15.93H16.6926L16.3885 9.80064C16.3847 9.79191 16.3807 9.78241 16.3764 9.7722C16.3313 9.66555 16.254 9.48249 16.0596 9.30863C15.8713 9.14007 15.5988 8.99893 15.2018 8.84423ZM15.2018 8.84423C15.202 8.8443 15.2022 8.84438 15.2024 8.84445L15.02 9.31M15.2018 8.84423C15.2017 8.84419 15.2016 8.84415 15.2015 8.84411L15.02 9.31M15.02 9.31C15.1999 9.38008 15.3399 9.44252 15.4502 9.5H8.54445C8.65596 9.44252 8.79779 9.38008 8.98 9.31C9.95 8.93 10.97 8.75 12 8.75C13.03 8.75 14.05 8.93 15.02 9.31ZM4 8.5C4.12433 8.5 4.24703 8.50445 4.36911 8.51269C4.13165 9.09505 4 9.72786 4 10.39V11.5H0.5V10.43C0.5 9.82187 0.859238 9.28075 1.41846 9.03893L1.41956 9.03845C2.20911 8.69476 3.08135 8.5 4 8.5ZM22.5804 9.03845L22.5815 9.03893C23.1408 9.28075 23.5 9.82187 23.5 10.43V11.5H20V10.39C20 9.72786 19.8684 9.09505 19.6309 8.51269C19.753 8.50445 19.8757 8.5 20 8.5C20.9186 8.5 21.7909 8.69476 22.5804 9.03845ZM5.5 5C5.5 5.82386 4.82386 6.5 4 6.5C3.17614 6.5 2.5 5.82386 2.5 5C2.5 4.17614 3.17614 3.5 4 3.5C4.82386 3.5 5.5 4.17614 5.5 5ZM21.5 5C21.5 5.82386 20.8239 6.5 20 6.5C19.1761 6.5 18.5 5.82386 18.5 5C18.5 4.17614 19.1761 3.5 20 3.5C20.8239 3.5 21.5 4.17614 21.5 5ZM12 7.25C13.5517 7.25 14.9228 7.61175 16.0369 8.1069C16.9307 8.50413 17.5 9.4013 17.5 10.39V11.5H6.5V10.39C6.5 9.40191 7.06861 8.50524 7.96141 8.10764C9.07967 7.62042 10.4511 7.25 12 7.25ZM13.5 3C13.5 2.17386 12.8261 1.5 12 1.5C11.1739 1.5 10.5 2.17386 10.5 3C10.5 3.82614 11.1739 4.5 12 4.5C12.8261 4.5 13.5 3.82614 13.5 3ZM9.5 3C9.5 1.61614 10.6161 0.5 12 0.5C13.3839 0.5 14.5 1.61614 14.5 3C14.5 4.38386 13.3839 5.5 12 5.5C10.6161 5.5 9.5 4.38386 9.5 3Z"
            fill={color.grey550}
            stroke={color.grey550}
        />
    </svg>
);

export const DashboardPropertyIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
        <g clipPath="url(#clip0_1520_708)">
            <path d="M0 0H22V22H0V0Z" fill={color.primaryMain} />
            <path
                opacity="0.3"
                d="M11 10.0833H12.8333V11.9167H11V13.75H12.8333V15.5833H11V17.4167H18.3333V8.25H11V10.0833ZM14.6667 10.0833H16.5V11.9167H14.6667V10.0833ZM14.6667 13.75H16.5V15.5833H14.6667V13.75Z"
                fill={color.grey550}
            />
            <path
                d="M11 6.41667V2.75H1.83333V19.25H20.1667V6.41667H11ZM5.5 17.4167H3.66667V15.5833H5.5V17.4167ZM5.5 13.75H3.66667V11.9167H5.5V13.75ZM5.5 10.0833H3.66667V8.25H5.5V10.0833ZM5.5 6.41667H3.66667V4.58333H5.5V6.41667ZM9.16667 17.4167H7.33333V15.5833H9.16667V17.4167ZM9.16667 13.75H7.33333V11.9167H9.16667V13.75ZM9.16667 10.0833H7.33333V8.25H9.16667V10.0833ZM9.16667 6.41667H7.33333V4.58333H9.16667V6.41667ZM18.3333 17.4167H11V15.5833H12.8333V13.75H11V11.9167H12.8333V10.0833H11V8.25H18.3333V17.4167ZM14.6667 10.0833H16.5V11.9167H14.6667V10.0833ZM14.6667 13.75H16.5V15.5833H14.6667V13.75Z"
                fill={color.secondaryLight}
            />
        </g>
        <defs>
            <clipPath id="clip0_1520_708">
                <rect width="22" height="22" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const DashboardClientsIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
        <path
            d="M11.275 11.2016C11.7641 10.7782 12.1564 10.2546 12.4253 9.66619C12.6942 9.07782 12.8333 8.43849 12.8333 7.79158C12.8333 6.57601 12.3504 5.41022 11.4909 4.55068C10.6314 3.69114 9.46557 3.20825 8.24999 3.20825C7.03441 3.20825 5.86863 3.69114 5.00908 4.55068C4.14954 5.41022 3.66666 6.57601 3.66666 7.79158C3.66665 8.43849 3.80581 9.07782 4.07469 9.66619C4.34357 10.2546 4.73588 10.7782 5.22499 11.2016C3.94178 11.7826 2.85308 12.721 2.08906 13.9044C1.32503 15.0878 0.918006 16.4663 0.916656 17.8749C0.916656 18.118 1.01323 18.3512 1.18514 18.5231C1.35705 18.695 1.59021 18.7916 1.83332 18.7916C2.07644 18.7916 2.3096 18.695 2.4815 18.5231C2.65341 18.3512 2.74999 18.118 2.74999 17.8749C2.74999 16.4162 3.32945 15.0173 4.3609 13.9858C5.39235 12.9544 6.7913 12.3749 8.24999 12.3749C9.70868 12.3749 11.1076 12.9544 12.1391 13.9858C13.1705 15.0173 13.75 16.4162 13.75 17.8749C13.75 18.118 13.8466 18.3512 14.0185 18.5231C14.1904 18.695 14.4235 18.7916 14.6667 18.7916C14.9098 18.7916 15.1429 18.695 15.3148 18.5231C15.4867 18.3512 15.5833 18.118 15.5833 17.8749C15.582 16.4663 15.175 15.0878 14.4109 13.9044C13.6469 12.721 12.5582 11.7826 11.275 11.2016ZM8.24999 10.5416C7.70609 10.5416 7.17441 10.3803 6.72217 10.0781C6.26994 9.77595 5.91746 9.34646 5.70932 8.84396C5.50118 8.34147 5.44672 7.78853 5.55283 7.25509C5.65894 6.72164 5.92085 6.23164 6.30545 5.84704C6.69004 5.46245 7.18004 5.20054 7.71349 5.09443C8.24694 4.98832 8.79987 5.04278 9.30237 5.25092C9.80487 5.45906 10.2344 5.81153 10.5365 6.26377C10.8387 6.716 11 7.24769 11 7.79158C11 8.52093 10.7103 9.2204 10.1945 9.73613C9.67881 10.2519 8.97934 10.5416 8.24999 10.5416ZM17.1783 10.8349C17.765 10.1743 18.1482 9.35822 18.2818 8.4849C18.4155 7.61157 18.2938 6.71824 17.9316 5.91242C17.5694 5.1066 16.982 4.42265 16.2401 3.94289C15.4982 3.46313 14.6335 3.20802 13.75 3.20825C13.5069 3.20825 13.2737 3.30483 13.1018 3.47674C12.9299 3.64865 12.8333 3.8818 12.8333 4.12492C12.8333 4.36803 12.9299 4.60119 13.1018 4.7731C13.2737 4.94501 13.5069 5.04159 13.75 5.04159C14.4793 5.04159 15.1788 5.33132 15.6945 5.84704C16.2103 6.36277 16.5 7.06224 16.5 7.79158C16.4987 8.27306 16.371 8.74575 16.1297 9.16239C15.8884 9.57903 15.542 9.92502 15.125 10.1658C14.9891 10.2441 14.8756 10.3561 14.7953 10.4909C14.7151 10.6257 14.6708 10.7789 14.6667 10.9358C14.6628 11.0914 14.6987 11.2454 14.7708 11.3833C14.843 11.5212 14.9491 11.6385 15.0792 11.7241L15.4367 11.9624L15.5558 12.0266C16.6608 12.5507 17.5929 13.3796 18.2426 14.4157C18.8922 15.4518 19.2322 16.652 19.2225 17.8749C19.2225 18.118 19.3191 18.3512 19.491 18.5231C19.6629 18.695 19.896 18.7916 20.1392 18.7916C20.3823 18.7916 20.6154 18.695 20.7873 18.5231C20.9592 18.3512 21.0558 18.118 21.0558 17.8749C21.0633 16.4682 20.711 15.083 20.0323 13.8508C19.3537 12.6186 18.3712 11.5805 17.1783 10.8349Z"
            fill="white"
        />
    </svg>
);

export const BreadCrumbIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 16 16" fill="none">
        <g clipPath="url(#clip0_1532_710)">
            <path d="M0 0H16V16H0V0Z" fill={color.primaryLight} />
            <path opacity="0.3" d="M10 4.66667H5.26001L7.64001 8L5.26001 11.3333H10L12.3667 8L10 4.66667Z" fill={color.grey550} />
            <path
                d="M11.0867 3.89333C10.8467 3.55333 10.4467 3.33333 10 3.33333H2.66669L6.00002 8L2.66669 12.66H10C10.4467 12.66 10.8467 12.4467 11.0867 12.1067L14 8L11.0867 3.89333ZM10 11.3333H5.26002L7.64002 8L5.26002 4.66666H10L12.3667 8L10 11.3333Z"
                fill={color.grey550}
            />
        </g>
        <defs>
            <clipPath id="clip0_1532_710">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const PropertyTimelineIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M19 4H5C4.44772 4 4 4.44771 4 5V7C4 7.55228 4.44772 8 5 8H19C19.5523 8 20 7.55228 20 7V5C20 4.44771 19.5523 4 19 4Z"
            stroke={color.grey550}
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M9 12H5C4.44772 12 4 12.4477 4 13V19C4 19.5523 4.44772 20 5 20H9C9.55228 20 10 19.5523 10 19V13C10 12.4477 9.55228 12 9 12Z"
            stroke={color.grey550}
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path d="M14 12H20" stroke={color.grey550} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M14 16H20" stroke={color.grey550} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M14 20H20" stroke={color.grey550} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
);

export const PropertyCardsIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            opacity="0.3"
            d="M12 4C7.59 4 4 7.59 4 12C4 13.82 4.62 15.49 5.64 16.83C7.07 15.09 10.54 14.5 12 14.5C13.46 14.5 16.93 15.09 18.36 16.83C19.38 15.49 20 13.82 20 12C20 7.59 16.41 4 12 4ZM12 13C10.06 13 8.5 11.44 8.5 9.5C8.5 7.56 10.06 6 12 6C13.94 6 15.5 7.56 15.5 9.5C15.5 11.44 13.94 13 12 13Z"
            fill={color.grey550}
        />
        <path
            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM7.07 18.28C7.5 17.38 10.12 16.5 12 16.5C13.88 16.5 16.51 17.38 16.93 18.28C15.57 19.36 13.86 20 12 20C10.14 20 8.43 19.36 7.07 18.28ZM18.36 16.83C16.93 15.09 13.46 14.5 12 14.5C10.54 14.5 7.07 15.09 5.64 16.83C4.62 15.49 4 13.82 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 13.82 19.38 15.49 18.36 16.83ZM12 6C10.06 6 8.5 7.56 8.5 9.5C8.5 11.44 10.06 13 12 13C13.94 13 15.5 11.44 15.5 9.5C15.5 7.56 13.94 6 12 6ZM12 11C11.17 11 10.5 10.33 10.5 9.5C10.5 8.67 11.17 8 12 8C12.83 8 13.5 8.67 13.5 9.5C13.5 10.33 12.83 11 12 11Z"
            fill={color.grey550}
        />
    </svg>
);

export const PropertyCalenderIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M20 3H19V1H17V3H7V1H5V3H4C2.9 3 2 3.9 2 5V21C2 22.1 2.9 23 4 23H20C21.1 23 22 22.1 22 21V5C22 3.9 21.1 3 20 3ZM20 5V8H4V5H20ZM4 21V10H20V21H4Z"
            fill={color.grey550}
        />
        <path opacity="0.3" d="M4 5.01H20V8H4V5.01Z" fill={color.grey550} />
    </svg>
);

export const PropertyListIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
        <g clipPath="url(#clip0_1532_821)">
            <path
                d="M18 4.5H6C4.89543 4.5 4 5.39543 4 6.5V8.5C4 9.60457 4.89543 10.5 6 10.5H18C19.1046 10.5 20 9.60457 20 8.5V6.5C20 5.39543 19.1046 4.5 18 4.5Z"
                stroke={color.grey550}
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M18 14.5H6C4.89543 14.5 4 15.3954 4 16.5V18.5C4 19.6046 4.89543 20.5 6 20.5H18C19.1046 20.5 20 19.6046 20 18.5V16.5C20 15.3954 19.1046 14.5 18 14.5Z"
                stroke={color.grey550}
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_1532_821">
                <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
            </clipPath>
        </defs>
    </svg>
);

export const PropertyMapsIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
        <g clipPath="url(#clip0_1532_257)">
            <path
                d="M3 7.5L9 4.5L15 7.5L21 4.5V17.5L15 20.5L9 17.5L3 20.5V7.5Z"
                stroke="#757575"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path d="M9 4.5V17.5" stroke="#757575" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M15 7.5V20.5" stroke="#757575" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_1532_257">
                <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
            </clipPath>
        </defs>
    </svg>
);

export const PropertyFilterIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
        <g clipPath="url(#clip0_1532_1173)">
            <path d="M10 18.5H14V16.5H10V18.5ZM3 6.5V8.5H21V6.5H3ZM6 13.5H18V11.5H6V13.5Z" fill={color.grey550} />
        </g>
        <defs>
            <clipPath id="clip0_1532_1173">
                <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
            </clipPath>
        </defs>
    </svg>
);

export const PropertyPrintIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
        <g clipPath="url(#clip0_1532_673)">
            <path opacity="0.3" d="M8.5 6H15.5V8H8.5V6Z" fill={color.grey550} stroke="#757575" />
            <path
                d="M18.5 12C18.5 12.2761 18.2761 12.5 18 12.5C17.7239 12.5 17.5 12.2761 17.5 12C17.5 11.7239 17.7239 11.5 18 11.5C18.2761 11.5 18.5 11.7239 18.5 12Z"
                fill={color.grey550}
                stroke="#757575"
            />
            <path
                d="M19 8.5H18V3.5H6V8.5H5C3.34 8.5 2 9.84 2 11.5V17.5H6V21.5H18V17.5H22V11.5C22 9.84 20.66 8.5 19 8.5ZM8 5.5H16V8.5H8V5.5ZM16 19.5H8V15.5H16V19.5ZM20 15.5H18V13.5H6V15.5H4V11.5C4 10.95 4.45 10.5 5 10.5H19C19.55 10.5 20 10.95 20 11.5V15.5Z"
                fill={color.grey550}
            />
            <path
                opacity="0.3"
                d="M6 13.5H18V15.5H20V11.5C20 10.95 19.55 10.5 19 10.5H5C4.45 10.5 4 10.95 4 11.5V15.5H6V13.5ZM18 11C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13C17.45 13 17 12.55 17 12C17 11.45 17.45 11 18 11Z"
                fill={color.grey550}
            />
        </g>
        <defs>
            <clipPath id="clip0_1532_673">
                <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
            </clipPath>
        </defs>
    </svg>
);

export const PropertyExportIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
        <g clipPath="url(#clip0_1532_1221)">
            <path d="M3.5 20.5V21H4H17.5V22H4C3.17614 22 2.5 21.3239 2.5 20.5V7H3.5V20.5Z" fill={color.grey550} stroke="#757575" />
            <path
                opacity="0.3"
                d="M17 8H16.5V8.5V9.5C16.5 8.67386 15.8261 8 15 8H13H12.5V8.5V9.5C12.5 8.67386 11.8261 8 11 8H9H8.5V5H19.5V8H19H17ZM19.5 12V16H8.5V14H9H10H10.5V13.5V12H11C11.8261 12 12.5 11.3261 12.5 10.5V13.5V14H13H15C15.8261 14 16.5 13.3261 16.5 12.5V13.5V14H17H18H18.5V13.5V12H19H19.5Z"
                fill={color.grey550}
                stroke="#757575"
            />
            <path
                d="M20 2.5H8C6.9 2.5 6 3.4 6 4.5V16.5C6 17.6 6.9 18.5 8 18.5H20C21.1 18.5 22 17.6 22 16.5V4.5C22 3.4 21.1 2.5 20 2.5ZM20 16.5H8V4.5H20V16.5ZM16 12.5V9.5C16 8.95 15.55 8.5 15 8.5H13V13.5H15C15.55 13.5 16 13.05 16 12.5ZM14 9.5H15V12.5H14V9.5ZM18 11.5H19V10.5H18V9.5H19V8.5H17V13.5H18V11.5ZM10 11.5H11C11.55 11.5 12 11.05 12 10.5V9.5C12 8.95 11.55 8.5 11 8.5H9V13.5H10V11.5ZM10 9.5H11V10.5H10V9.5Z"
                fill={color.grey550}
            />
        </g>
        <defs>
            <clipPath id="clip0_1532_1221">
                <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
            </clipPath>
        </defs>
    </svg>
);

export const AddNewPropertyIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
        <g clipPath="url(#clip0_1532_317)">
            <path
                d="M12 7.5C11.45 7.5 11 7.95 11 8.5V11.5H8C7.45 11.5 7 11.95 7 12.5C7 13.05 7.45 13.5 8 13.5H11V16.5C11 17.05 11.45 17.5 12 17.5C12.55 17.5 13 17.05 13 16.5V13.5H16C16.55 13.5 17 13.05 17 12.5C17 11.95 16.55 11.5 16 11.5H13V8.5C13 7.95 12.55 7.5 12 7.5ZM12 2.5C6.48 2.5 2 6.98 2 12.5C2 18.02 6.48 22.5 12 22.5C17.52 22.5 22 18.02 22 12.5C22 6.98 17.52 2.5 12 2.5ZM12 20.5C7.59 20.5 4 16.91 4 12.5C4 8.09 7.59 4.5 12 4.5C16.41 4.5 20 8.09 20 12.5C20 16.91 16.41 20.5 12 20.5Z"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0_1532_317">
                <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
            </clipPath>
        </defs>
    </svg>
);

export const CalendarToday = ({ height = '16', width = '16' }) => (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12 3.3334H3.99996C3.26358 3.3334 2.66663 3.93036 2.66663 4.66674V12.6667C2.66663 13.4031 3.26358 14.0001 3.99996 14.0001H12C12.7363 14.0001 13.3333 13.4031 13.3333 12.6667V4.66674C13.3333 3.93036 12.7363 3.3334 12 3.3334Z"
            stroke={color.grey550}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path d="M10.6653 2V4.66667" stroke={color.grey550} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M5.3291 2V4.66667" stroke={color.grey550} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M2.66663 7.33316H13.3333" stroke={color.grey550} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M7.33008 9.99994H7.99674" stroke={color.grey550} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M7.99731 9.99994V11.9999" stroke={color.grey550} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
);

export const WalletIcon = (
    <svg width="2rem" height=" 2rem" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2195_8687)">
            <path
                opacity="0.3"
                d="M17.3333 23.1667C15.8666 23.1667 14.6666 21.9667 14.6666 20.5V12.5C14.6666 11.0334 15.8666 9.83335 17.3333 9.83335H25.3333V7.16669H6.66663V25.8334H25.3333V23.1667H17.3333Z"
                fill="white"
            />
            <path
                d="M28 10.2067V7.16667C28 5.7 26.8 4.5 25.3333 4.5H6.66667C5.18667 4.5 4 5.7 4 7.16667V25.8333C4 27.3 5.18667 28.5 6.66667 28.5H25.3333C26.8 28.5 28 27.3 28 25.8333V22.7933C28.7867 22.3267 29.3333 21.4867 29.3333 20.5V12.5C29.3333 11.5133 28.7867 10.66 28 10.2067ZM26.6667 12.5V20.5H17.3333V12.5H26.6667ZM6.66667 25.8333V7.16667H25.3333V9.83333H17.3333C15.8667 9.83333 14.6667 11.0333 14.6667 12.5V20.5C14.6667 21.9667 15.8667 23.1667 17.3333 23.1667H25.3333V25.8333H6.66667Z"
                fill="white"
            />
            <path
                d="M21.3334 18.5C22.4379 18.5 23.3334 17.6046 23.3334 16.5C23.3334 15.3954 22.4379 14.5 21.3334 14.5C20.2288 14.5 19.3334 15.3954 19.3334 16.5C19.3334 17.6046 20.2288 18.5 21.3334 18.5Z"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0_2195_8687">
                <rect width="32" height="32" fill="white" transform="translate(0 0.5)" />
            </clipPath>
        </defs>
    </svg>
);
export const DocumentFilesIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clip-path="url(#clip0_1918_72)">
            <path opacity="0.3" d="M13 4.00003H6V20H18V9.00003H13V4.00003Z" fill={color.grey550} />
            <path
                d="M20 8.00003L14 2.00003H6C4.9 2.00003 4.01 2.90003 4.01 4.00003L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8.00003ZM18 20H6V4.00003H13V9.00003H18V20Z"
                fill={color.grey550}
            />
        </g>
        <defs>
            <clipPath id="clip0_1918_72">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const DocumentFilesIconWhite = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path opacity="0.3" d="M12.5 9V9.5H13H17.5V19.5H6.5V4.5H12.5V9Z" stroke={color.primaryMain} />
        <path
            d="M4.51 4.00031V4C4.51 3.17287 5.1794 2.5 6 2.5H13.7929L19.5 8.20711V20C19.5 20.8239 18.8239 21.5 18 21.5H5.99C5.16945 21.5 4.50008 20.8272 4.5 20.0002C4.5 20.0001 4.5 20.0001 4.5 20L4.51 4.00031ZM18 20.5H18.5V20V9V8.5H18H13.5V4V3.5H13H6H5.5V4V20V20.5H6H18Z"
            stroke={color.primaryMain}
        />
    </svg>
);

export const InfoGraphic = (
    <svg width="2rem" height=" 2rem" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M14.6667 9.83333C14.6667 12.7789 12.2789 15.1667 9.33333 15.1667C6.38781 15.1667 4 12.7789 4 9.83333C4 6.88781 6.38781 4.5 9.33333 4.5M14.6667 9.83333C14.6667 6.88781 12.2789 4.5 9.33333 4.5M14.6667 9.83333H9.33333V4.5M12 23.1667V28.5M22.6667 19.1667V28.5M17.3333 17.8333V28.5M28 16.5V28.5"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);

export const BuilderIcon = (
    <svg width="2rem" height=" 2rem" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2195_13258)">
            <path
                opacity="0.3"
                d="M16 15.1667H18.6667V17.8333H16V20.5H18.6667V23.1667H16V25.8333H26.6667V12.5H16V15.1667ZM21.3333 15.1667H24V17.8333H21.3333V15.1667ZM21.3333 20.5H24V23.1667H21.3333V20.5Z"
                fill="white"
            />
            <path
                d="M16 9.83333V4.5H2.66663V28.5H29.3333V9.83333H16ZM7.99996 25.8333H5.33329V23.1667H7.99996V25.8333ZM7.99996 20.5H5.33329V17.8333H7.99996V20.5ZM7.99996 15.1667H5.33329V12.5H7.99996V15.1667ZM7.99996 9.83333H5.33329V7.16667H7.99996V9.83333ZM13.3333 25.8333H10.6666V23.1667H13.3333V25.8333ZM13.3333 20.5H10.6666V17.8333H13.3333V20.5ZM13.3333 15.1667H10.6666V12.5H13.3333V15.1667ZM13.3333 9.83333H10.6666V7.16667H13.3333V9.83333ZM26.6666 25.8333H16V23.1667H18.6666V20.5H16V17.8333H18.6666V15.1667H16V12.5H26.6666V25.8333ZM21.3333 15.1667H24V17.8333H21.3333V15.1667ZM21.3333 20.5H24V23.1667H21.3333V20.5Z"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0_2195_13258">
                <rect width="32" height="32" fill="white" transform="translate(0 0.5)" />
            </clipPath>
        </defs>
    </svg>
);
export const DocumentOptionIcon1 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clip-path="url(#clip0_280_110389)">
            <path
                d="M4 8H8V4H4V8ZM10 20H14V16H10V20ZM4 20H8V16H4V20ZM4 14H8V10H4V14ZM10 14H14V10H10V14ZM16 4V8H20V4H16ZM10 8H14V4H10V8ZM16 14H20V10H16V14ZM16 20H20V16H16V20Z"
                fill={color.primaryMedium}
            />
        </g>
        <defs>
            <clipPath id="clip0_280_110389">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const TickIcon = (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2195_12676)">
            <path
                d="M16.0001 2.66669C8.64008 2.66669 2.66675 8.64002 2.66675 16C2.66675 23.36 8.64008 29.3334 16.0001 29.3334C23.3601 29.3334 29.3334 23.36 29.3334 16C29.3334 8.64002 23.3601 2.66669 16.0001 2.66669ZM13.3334 22.6667L6.66675 16L8.54675 14.12L13.3334 18.8934L23.4534 8.77335L25.3334 10.6667L13.3334 22.6667Z"
                fill={color.primaryDark}
            />
        </g>
        <defs>
            <clipPath id="clip0_2195_12676">
                <rect width="32" height="32" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
export const DocumentOptionIcon2 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clip-path="url(#clip0_280_110390)">
            <path
                opacity="0.3"
                d="M12 4C7.59 4 4 7.59 4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4ZM13 17H11V11H13V17ZM13 9H11V7H13V9Z"
                fill={color.primaryMedium}
            />
            <path
                d="M11 7H13V9H11V7ZM11 11H13V17H11V11ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
                fill={color.primaryMedium}
            />
        </g>
        <defs>
            <clipPath id="clip0_280_110390">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const BuilderIconDark = (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2195_13290)">
            <path
                opacity="0.3"
                d="M16 14.6667H18.6667V17.3333H16V20H18.6667V22.6667H16V25.3333H26.6667V12H16V14.6667ZM21.3333 14.6667H24V17.3333H21.3333V14.6667ZM21.3333 20H24V22.6667H21.3333V20Z"
                fill="#271F16"
            />
            <path
                d="M16 9.33333V4H2.66663V28H29.3333V9.33333H16ZM7.99996 25.3333H5.33329V22.6667H7.99996V25.3333ZM7.99996 20H5.33329V17.3333H7.99996V20ZM7.99996 14.6667H5.33329V12H7.99996V14.6667ZM7.99996 9.33333H5.33329V6.66667H7.99996V9.33333ZM13.3333 25.3333H10.6666V22.6667H13.3333V25.3333ZM13.3333 20H10.6666V17.3333H13.3333V20ZM13.3333 14.6667H10.6666V12H13.3333V14.6667ZM13.3333 9.33333H10.6666V6.66667H13.3333V9.33333ZM26.6666 25.3333H16V22.6667H18.6666V20H16V17.3333H18.6666V14.6667H16V12H26.6666V25.3333ZM21.3333 14.6667H24V17.3333H21.3333V14.6667ZM21.3333 20H24V22.6667H21.3333V20Z"
                fill={color.grey550}
            />
        </g>
        <defs>
            <clipPath id="clip0_2195_13290">
                <rect width="32" height="32" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
export const DocumentRecentIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
            opacity="0.3"
            d="M10 2.00003C5.59 2.00003 2 5.59003 2 10C2 14.41 5.59 18 10 18C14.41 18 18 14.41 18 10C18 5.59003 14.41 2.00003 10 2.00003ZM14.2 14.2L9 11V5.00003H10.5V10.2L15 12.9L14.2 14.2Z"
            fill={color.grey550}
        />
        <path
            d="M10 3.05176e-05C4.5 3.05176e-05 0 4.50003 0 10C0 15.5 4.5 20 10 20C15.5 20 20 15.5 20 10C20 4.50003 15.5 3.05176e-05 10 3.05176e-05ZM10 18C5.59 18 2 14.41 2 10C2 5.59003 5.59 2.00003 10 2.00003C14.41 2.00003 18 5.59003 18 10C18 14.41 14.41 18 10 18ZM10.5 5.00003H9V11L14.2 14.2L15 12.9L10.5 10.2V5.00003Z"
            fill={color.grey550}
        />
    </svg>
);
export const DocumentStaredIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clip-path="url(#clip0_1918_62)">
            <path
                opacity="0.3"
                d="M17.11 10.83L14.64 10.62L13.44 10.52L12.97 9.41004L12 7.13004L11.03 9.41004L10.56 10.52L9.36001 10.62L6.89001 10.83L8.77002 12.46L9.68002 13.25L9.41001 14.42L8.84001 16.84L10.97 15.56L12 14.93L13.03 15.56L15.16 16.84L14.59 14.42L14.32 13.25L15.23 12.46L17.11 10.83Z"
                fill={color.grey550}
            />
            <path
                d="M22 9.24003L14.81 8.63003L12 2.00003L9.19 8.63003L2 9.24003L7.46 13.97L5.82 21L12 17.27L18.18 21L16.54 13.97L22 9.24003ZM14.59 14.42L15.15 16.83L13.03 15.55L12 14.93L10.97 15.55L8.85 16.83L9.41 14.42L9.68 13.24L8.77 12.45L6.89 10.82L9.36 10.61L10.56 10.51L11.03 9.40003L12 7.13003L12.97 9.42003L13.44 10.53L14.64 10.63L17.11 10.84L15.23 12.47L14.32 13.26L14.59 14.42Z"
                fill={color.grey550}
            />
        </g>
        <defs>
            <clipPath id="clip0_1918_62">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const DevelopmentDark = (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2195_13313)">
            <path
                opacity="0.3"
                d="M6.66663 6.66667H12V12H6.66663V6.66667ZM20 20H25.3333V25.3333H20V20ZM6.66663 20H12V25.3333H6.66663V20ZM22.2133 6.02667L18.44 9.78667L22.2133 13.56L25.9866 9.78667L22.2133 6.02667Z"
                fill={color.primaryDark}
            />
            <path
                d="M22.2133 2.25336L14.6667 9.78669L22.2133 17.3334L29.76 9.78669L22.2133 2.25336V2.25336ZM18.44 9.78669L22.2133 6.01336L25.9867 9.78669L22.2133 13.56L18.44 9.78669V9.78669ZM4 4.00002V14.6667H14.6667V4.00002H4ZM12 12H6.66667V6.66669H12V12ZM4 28H14.6667V17.3334H4V28ZM6.66667 20H12V25.3334H6.66667V20ZM17.3333 17.3334V28H28V17.3334H17.3333ZM25.3333 25.3334H20V20H25.3333V25.3334Z"
                fill={color.grey550}
            />
        </g>
        <defs>
            <clipPath id="clip0_2195_13313">
                <rect width="32" height="32" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
export const DocumentTrashIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clip-path="url(#clip0_1918_255)">
            <path opacity="0.3" d="M8 9.00003H16V19H8V9.00003Z" fill={color.grey550} />
            <path
                d="M15.5 4.00003L14.5 3.00003H9.5L8.5 4.00003H5V6.00003H19V4.00003H15.5ZM6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7.00003H6V19ZM8 9.00003H16V19H8V9.00003Z"
                fill={color.grey550}
            />
        </g>
        <defs>
            <clipPath id="clip0_1918_255">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const ImpDeviceDark = (
    <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1645_19524)">
            <path
                d="M30.6668 15.18L24.0001 15.1666C23.2668 15.1666 22.6668 15.7666 22.6668 16.5V28.5C22.6668 29.2333 23.2668 29.8333 24.0001 29.8333H30.6668C31.4001 29.8333 32.0001 29.2333 32.0001 28.5V16.5C32.0001 15.7666 31.4001 15.18 30.6668 15.18ZM30.6668 27.1666H24.0001V17.8333H30.6668V27.1666ZM26.6668 3.16663H2.66679C1.20012 3.16663 0.00012207 4.36663 0.00012207 5.83329V21.8333C0.00012207 23.3 1.20012 24.5 2.66679 24.5H12.0001V27.1666H10.6668C9.93346 27.1666 9.33346 27.7666 9.33346 28.5C9.33346 29.2333 9.93346 29.8333 10.6668 29.8333H18.6668C19.4001 29.8333 20.0001 29.2333 20.0001 28.5C20.0001 27.7666 19.4001 27.1666 18.6668 27.1666H17.3335V24.5H18.6668C19.4001 24.5 20.0001 23.9 20.0001 23.1666C20.0001 22.4333 19.4001 21.8333 18.6668 21.8333H4.00012C3.26679 21.8333 2.66679 21.2333 2.66679 20.5V7.16663C2.66679 6.43329 3.26679 5.83329 4.00012 5.83329H25.3335C26.0668 5.83329 26.6668 6.43329 26.6668 7.16663V11.1666C26.6668 11.9 27.2668 12.5 28.0001 12.5C28.7335 12.5 29.3335 11.9 29.3335 11.1666V5.83329C29.3335 4.36663 28.1335 3.16663 26.6668 3.16663ZM15.9601 12.5L14.6668 8.49996L13.3735 12.5H9.33346L12.6268 14.8466L11.3735 18.7266L14.6668 16.3266L17.9601 18.7266L16.7068 14.8466L20.0001 12.5H15.9601Z"
                fill={color.primaryDark}
            />
        </g>
        <defs>
            <clipPath id="clip0_1645_19524">
                <rect width="32" height="32" fill="white" transform="translate(0.00012207 0.5)" />
            </clipPath>
        </defs>
    </svg>
);
export const DocumentsTableIcon1 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clip-path="url(#clip0_2136_2724)">
            <path
                opacity="0.3"
                d="M11.17 8.00006L10.58 7.41006L9.17 6.00006H4V18.0001H20V8.00006H11.17ZM19 16.0001V17.0001H11V16.0001C11 14.6701 13.67 14.0001 15 14.0001C16.33 14.0001 19 14.6701 19 16.0001ZM15 9.00006C16.1 9.00006 17 9.90006 17 11.0001C17 12.1001 16.1 13.0001 15 13.0001C13.9 13.0001 13 12.1001 13 11.0001C13 9.90006 13.9 9.00006 15 9.00006Z"
                fill={color.grey550}
            />
            <path
                d="M20 6.00006H12L10 4.00006H4C2.9 4.00006 2.01 4.90006 2.01 6.00006L2 18.0001C2 19.1001 2.9 20.0001 4 20.0001H20C21.1 20.0001 22 19.1001 22 18.0001V8.00006C22 6.90006 21.1 6.00006 20 6.00006ZM20 18.0001H4V6.00006H9.17L11.17 8.00006H20V18.0001ZM15 13.0001C16.1 13.0001 17 12.1001 17 11.0001C17 9.90006 16.1 9.00006 15 9.00006C13.9 9.00006 13 9.90006 13 11.0001C13 12.1001 13.9 13.0001 15 13.0001ZM11 16.0001V17.0001H19V16.0001C19 14.6701 16.33 14.0001 15 14.0001C13.67 14.0001 11 14.6701 11 16.0001Z"
                fill={color.grey550}
            />
        </g>
        <defs>
            <clipPath id="clip0_2136_2724">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const ProfileLight = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2195_10897)">
            <path
                d="M19 4H5C4.44772 4 4 4.44772 4 5V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V5C20 4.44772 19.5523 4 19 4Z"
                stroke={color.grey550}
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path d="M4 8H20" stroke={color.grey550} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M8 4V8" stroke={color.grey550} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_2195_10897">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
export const UnitsIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clip-path="url(#clip0_5064_17818)">
            <path opacity="0.3" d="M12 11H14V13H12V15H14V17H12V19H20V9H12V11ZM16 11H18V13H16V11ZM16 15H18V17H16V15Z" fill="#616161" />
            <path
                d="M12 7V3H2V21H22V7H12ZM6 19H4V17H6V19ZM6 15H4V13H6V15ZM6 11H4V9H6V11ZM6 7H4V5H6V7ZM10 19H8V17H10V19ZM10 15H8V13H10V15ZM10 11H8V9H10V11ZM10 7H8V5H10V7ZM20 19H12V17H14V15H12V13H14V11H12V9H20V19ZM16 11H18V13H16V11ZM16 15H18V17H16V15Z"
                fill="#616161"
            />
        </g>
        <defs>
            <clipPath id="clip0_5064_17818">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
export const DocumentsTableIcon2 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clip-path="url(#clip0_2136_2737)">
            <path d="M4 6.00006H2V20.0001C2 21.1001 2.9 22.0001 4 22.0001H18V20.0001H4V6.00006Z" fill={color.grey550} />
            <path
                opacity="0.3"
                d="M10 9.00006H11V10.0001H10V9.00006ZM14 9.00006H15V12.0001H14V9.00006ZM8 16.0001H20V4.00006H8V16.0001ZM17 8.00006H19V9.00006H18V10.0001H19V11.0001H18V13.0001H17V8.00006ZM13 8.00006H15C15.55 8.00006 16 8.45006 16 9.00006V12.0001C16 12.5501 15.55 13.0001 15 13.0001H13V8.00006ZM9 8.00006H11C11.55 8.00006 12 8.45006 12 9.00006V10.0001C12 10.5501 11.55 11.0001 11 11.0001H10V13.0001H9V8.00006Z"
                fill={color.grey550}
            />
            <path
                d="M20 2.00006H8C6.9 2.00006 6 2.90006 6 4.00006V16.0001C6 17.1001 6.9 18.0001 8 18.0001H20C21.1 18.0001 22 17.1001 22 16.0001V4.00006C22 2.90006 21.1 2.00006 20 2.00006ZM20 16.0001H8V4.00006H20V16.0001ZM16 12.0001V9.00006C16 8.45006 15.55 8.00006 15 8.00006H13V13.0001H15C15.55 13.0001 16 12.5501 16 12.0001ZM14 9.00006H15V12.0001H14V9.00006ZM18 11.0001H19V10.0001H18V9.00006H19V8.00006H17V13.0001H18V11.0001ZM10 11.0001H11C11.55 11.0001 12 10.5501 12 10.0001V9.00006C12 8.45006 11.55 8.00006 11 8.00006H9V13.0001H10V11.0001ZM10 9.00006H11V10.0001H10V9.00006Z"
                fill={color.grey550}
            />
        </g>
        <defs>
            <clipPath id="clip0_2136_2737">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const UserLight = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.99661 11.0003C11.2058 11.0003 12.9966 9.2094 12.9966 7.00026C12.9966 4.79112 11.2058 3.00026 8.99661 3.00026C6.78747 3.00026 4.99661 4.79112 4.99661 7.00026C4.99661 9.2094 6.78747 11.0003 8.99661 11.0003Z"
            stroke={color.grey550}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M3.00407 21V19C3.00407 17.9391 3.42549 16.9217 4.17564 16.1716C4.92578 15.4214 5.9432 15 7.00407 15H11.0041C12.0649 15 13.0823 15.4214 13.8325 16.1716C14.5826 16.9217 15.0041 17.9391 15.0041 19V21"
            stroke={color.grey550}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M16.0014 3.1301C16.8618 3.3504 17.6244 3.8508 18.169 4.55241C18.7136 5.25402 19.0092 6.11693 19.0092 7.0051C19.0092 7.89327 18.7136 8.75618 18.169 9.45779C17.6244 10.1594 16.8618 10.6598 16.0014 10.8801"
            stroke={color.grey550}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M21.0041 20.9998V18.9998C20.999 18.117 20.702 17.2606 20.1593 16.5642C19.6167 15.8678 18.8589 15.3705 18.0041 15.1498"
            stroke={color.grey550}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);

export const OtherUser = (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clip-path="url(#clip0_6388_6374)">
            <path opacity="0.3" d="M15 16C12.31 16 9.23 17.28 9 18H21C20.8 17.29 17.7 16 15 16Z" fill="#8B6F4E" />
            <path
                opacity="0.3"
                d="M15 10C16.1046 10 17 9.10457 17 8C17 6.89543 16.1046 6 15 6C13.8954 6 13 6.89543 13 8C13 9.10457 13.8954 10 15 10Z"
                fill="#8B6F4E"
            />
            <path
                d="M15 12C17.21 12 19 10.21 19 8C19 5.79 17.21 4 15 4C12.79 4 11 5.79 11 8C11 10.21 12.79 12 15 12ZM15 6C16.1 6 17 6.9 17 8C17 9.1 16.1 10 15 10C13.9 10 13 9.1 13 8C13 6.9 13.9 6 15 6ZM15 14C12.33 14 7 15.34 7 18V20H23V18C23 15.34 17.67 14 15 14ZM9 18C9.22 17.28 12.31 16 15 16C17.7 16 20.8 17.29 21 18H9ZM6 15V12H9V10H6V7H4V10H1V12H4V15H6Z"
                fill="#8B6F4E"
            />
        </g>
        <defs>
            <clipPath id="clip0_6388_6374">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
export const DocumentsIconLight = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2403_4658)">
            <path
                d="M19 4H5C4.44772 4 4 4.44772 4 5V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V5C20 4.44772 19.5523 4 19 4Z"
                stroke={color.grey550}
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path d="M4 8H20" stroke={color.grey550} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M8 4V8" stroke={color.grey550} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_2403_4658">
                {' '}
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
export const DocumentsTableIcon3 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clip-path="url(#clip0_2136_2763)">
            <path
                opacity="0.3"
                d="M8 16.0001H20V4.00006H8V16.0001ZM10 6.00006H18V8.00006H10V6.00006ZM10 9.00006H18V11.0001H10V9.00006ZM10 12.0001H14V14.0001H10V12.0001Z"
                fill={color.grey550}
            />
            <path
                d="M4 22.0001H18V20.0001H4V6.00006H2V20.0001C2 21.1001 2.9 22.0001 4 22.0001ZM6 4.00006V16.0001C6 17.1001 6.9 18.0001 8 18.0001H20C21.1 18.0001 22 17.1001 22 16.0001V4.00006C22 2.90006 21.1 2.00006 20 2.00006H8C6.9 2.00006 6 2.90006 6 4.00006ZM20 16.0001H8V4.00006H20V16.0001ZM10 9.00006H18V11.0001H10V9.00006ZM10 12.0001H14V14.0001H10V12.0001ZM10 6.00006H18V8.00006H10V6.00006Z"
                fill={color.grey550}
            />
        </g>
        <defs>
            <clipPath id="clip0_2136_2763"></clipPath>
        </defs>
    </svg>
);

export const FinancialsIconLight = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
            stroke={color.grey550}
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M16.924 11.132C16.7523 10.1581 16.2957 9.25698 15.6119 8.54259C14.9281 7.82819 14.0478 7.33261 13.0823 7.11852C12.1169 6.90443 11.1096 6.98144 10.1879 7.33981C9.26623 7.69818 8.4715 8.32183 7.90425 9.13187C7.337 9.94191 7.02269 10.902 7.00107 11.8907C6.97946 12.8793 7.25151 13.8522 7.78282 14.6863C8.31413 15.5203 9.08084 16.1781 9.98599 16.5764C10.8911 16.9747 11.8941 17.0957 12.868 16.924"
            stroke={color.grey550}
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M3 12C3 13.78 3.52784 15.5201 4.51677 17.0001C5.50571 18.4802 6.91131 19.6337 8.55585 20.3149C10.2004 20.9961 12.01 21.1743 13.7558 20.8271C15.5016 20.4798 17.1053 19.6226 18.364 18.364C19.6226 17.1053 20.4798 15.5016 20.8271 13.7558C21.1743 12.01 20.9961 10.2004 20.3149 8.55585C19.6337 6.91131 18.4802 5.50571 17.0001 4.51677C15.5201 3.52784 13.78 3 12 3"
            stroke={color.grey550}
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);

export const GalleryLight = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 7.99953H15.0055" stroke={color.grey550} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path
            d="M16.9962 4.00046H6.99622C5.33936 4.00046 3.99622 5.3436 3.99622 7.00046V17.0005C3.99622 18.6573 5.33936 20.0005 6.99622 20.0005H16.9962C18.6531 20.0005 19.9962 18.6573 19.9962 17.0005V7.00046C19.9962 5.3436 18.6531 4.00046 16.9962 4.00046Z"
            stroke={color.grey550}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M3.99622 15L7.99622 11C8.45227 10.5611 8.96961 10.3301 9.49622 10.3301C10.0228 10.3301 10.5402 10.5611 10.9962 11L15.9962 16"
            stroke={color.grey550}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M13.9982 14.0002L14.9982 13.0002C15.4542 12.5613 15.9716 12.3303 16.4982 12.3303C17.0248 12.3303 17.5421 12.5613 17.9982 13.0002L19.9982 15.0002"
            stroke={color.grey550}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);

export const MapIconLight = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Maps">
            <path
                id="Vector"
                d="M3 7L9 4L15 7L21 4V17L15 20L9 17L3 20V7Z"
                stroke="#757575"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path id="Vector_2" d="M9 4V17" stroke="#757575" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path id="Vector_3" d="M15 7V20" stroke="#757575" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </g>
    </svg>
);
export const FinancialsCounterCardIcon1 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="83" height="83" viewBox="0 0 83 83" fill="none">
        <g clip-path="url(#clip0_2059_5599)">
            <path
                opacity="0.3"
                d="M41.5 13.8333C26.2488 13.8333 13.8334 26.2488 13.8334 41.5C13.8334 47.7942 15.9775 53.5696 19.505 58.2038C24.4505 52.1863 36.4509 50.1458 41.5 50.1458C46.5492 50.1458 58.5496 52.1863 63.495 58.2038C67.0225 53.5696 69.1667 47.7942 69.1667 41.5C69.1667 26.2488 56.7513 13.8333 41.5 13.8333ZM41.5 44.9583C34.7909 44.9583 29.3959 39.5633 29.3959 32.8542C29.3959 26.145 34.7909 20.75 41.5 20.75C48.2092 20.75 53.6042 26.145 53.6042 32.8542C53.6042 39.5633 48.2092 44.9583 41.5 44.9583Z"
                fill={color.primaryMedium}
            />
            <path
                d="M41.5 6.91666C22.41 6.91666 6.91663 22.41 6.91663 41.5C6.91663 60.59 22.41 76.0833 41.5 76.0833C60.59 76.0833 76.0833 60.59 76.0833 41.5C76.0833 22.41 60.59 6.91666 41.5 6.91666ZM24.4504 63.2183C25.9375 60.1058 34.9983 57.0625 41.5 57.0625C48.0016 57.0625 57.097 60.1058 58.5495 63.2183C53.8462 66.9533 47.9325 69.1667 41.5 69.1667C35.0675 69.1667 29.1537 66.9533 24.4504 63.2183ZM63.495 58.2037C58.5495 52.1862 46.5491 50.1458 41.5 50.1458C36.4508 50.1458 24.4504 52.1862 19.505 58.2037C15.9775 53.5696 13.8333 47.7942 13.8333 41.5C13.8333 26.2487 26.2487 13.8333 41.5 13.8333C56.7512 13.8333 69.1666 26.2487 69.1666 41.5C69.1666 47.7942 67.0225 53.5696 63.495 58.2037V58.2037ZM41.5 20.75C34.7908 20.75 29.3958 26.145 29.3958 32.8542C29.3958 39.5633 34.7908 44.9583 41.5 44.9583C48.2091 44.9583 53.6041 39.5633 53.6041 32.8542C53.6041 26.145 48.2091 20.75 41.5 20.75ZM41.5 38.0417C38.6295 38.0417 36.3125 35.7246 36.3125 32.8542C36.3125 29.9837 38.6295 27.6667 41.5 27.6667C44.3704 27.6667 46.6875 29.9837 46.6875 32.8542C46.6875 35.7246 44.3704 38.0417 41.5 38.0417Z"
                fill={color.primaryMedium}
            />
        </g>
        <defs>
            <clipPath id="clip0_2059_5599">
                <rect width="83" height="83" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const FinancialsCounterCardIcon2 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="83" height="83" viewBox="0 0 83 83" fill="none">
        <g clip-path="url(#clip0_2059_5516)">
            <path
                opacity="0.3"
                d="M17.2917 27.6667V69.1667H65.7084V27.6667H17.2917ZM41.5 48.4167C31.955 48.4167 24.2084 40.67 24.2084 31.125H31.125C31.125 36.8658 35.7592 41.5 41.5 41.5C47.2409 41.5 51.875 36.8658 51.875 31.125H58.7917C58.7917 40.67 51.045 48.4167 41.5 48.4167Z"
                fill={color.primaryMedium}
            />
            <path
                d="M58.7917 20.75C58.7917 11.205 51.045 3.45834 41.5 3.45834C31.955 3.45834 24.2083 11.205 24.2083 20.75H17.2917C13.4875 20.75 10.375 23.8625 10.375 27.6667V69.1667C10.375 72.9708 13.4875 76.0833 17.2917 76.0833H65.7083C69.5125 76.0833 72.625 72.9708 72.625 69.1667V27.6667C72.625 23.8625 69.5125 20.75 65.7083 20.75H58.7917ZM41.5 10.375C47.2408 10.375 51.875 15.0092 51.875 20.75H31.125C31.125 15.0092 35.7592 10.375 41.5 10.375ZM65.7083 69.1667H17.2917V27.6667H65.7083V69.1667ZM41.5 41.5C35.7592 41.5 31.125 36.8658 31.125 31.125H24.2083C24.2083 40.67 31.955 48.4167 41.5 48.4167C51.045 48.4167 58.7917 40.67 58.7917 31.125H51.875C51.875 36.8658 47.2408 41.5 41.5 41.5Z"
                fill={color.primaryMedium}
            />
        </g>
        <defs>
            <clipPath id="clip0_2059_5516">
                <rect width="83" height="83" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const FinancialsCounterSubCardIcon1 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
        <g clip-path="url(#clip0_2059_5468)">
            <path
                opacity="0.3"
                d="M17.3333 23.1667C15.8666 23.1667 14.6666 21.9667 14.6666 20.5V12.5C14.6666 11.0333 15.8666 9.83334 17.3333 9.83334H25.3333V7.16667H6.66663V25.8333H25.3333V23.1667H17.3333Z"
                fill="white"
            />
            <path
                d="M28 10.2067V7.16667C28 5.7 26.8 4.5 25.3333 4.5H6.66667C5.18667 4.5 4 5.7 4 7.16667V25.8333C4 27.3 5.18667 28.5 6.66667 28.5H25.3333C26.8 28.5 28 27.3 28 25.8333V22.7933C28.7867 22.3267 29.3333 21.4867 29.3333 20.5V12.5C29.3333 11.5133 28.7867 10.66 28 10.2067ZM26.6667 12.5V20.5H17.3333V12.5H26.6667ZM6.66667 25.8333V7.16667H25.3333V9.83333H17.3333C15.8667 9.83333 14.6667 11.0333 14.6667 12.5V20.5C14.6667 21.9667 15.8667 23.1667 17.3333 23.1667H25.3333V25.8333H6.66667Z"
                fill="white"
            />
            <path
                d="M21.3334 18.5C22.4379 18.5 23.3334 17.6046 23.3334 16.5C23.3334 15.3954 22.4379 14.5 21.3334 14.5C20.2288 14.5 19.3334 15.3954 19.3334 16.5C19.3334 17.6046 20.2288 18.5 21.3334 18.5Z"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0_2059_5468">
                <rect width="32" height="32" fill="white" transform="translate(0 0.5)" />
            </clipPath>
        </defs>
    </svg>
);
export const FinancialsCounterSubCardIcon2 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="27" viewBox="0 0 28 27" fill="none">
        <path
            opacity="0.3"
            d="M24.6666 13.5C24.6666 7.60668 19.8933 2.83334 13.9999 2.83334C8.10658 2.83334 3.33325 7.60668 3.33325 13.5C3.33325 19.3933 8.10658 24.1667 13.9999 24.1667C19.8933 24.1667 24.6666 19.3933 24.6666 13.5ZM9.33325 8.16668C10.4399 8.16668 11.3333 9.06001 11.3333 10.1667C11.3333 11.2733 10.4399 12.1667 9.33325 12.1667C8.22659 12.1667 7.33325 11.2733 7.33325 10.1667C7.33325 9.06001 8.22659 8.16668 9.33325 8.16668ZM13.9999 21.5C10.9599 21.5 8.37325 19.2867 7.33325 16.1667H20.6666C19.6266 19.2867 17.0399 21.5 13.9999 21.5ZM18.6666 12.1667C17.5599 12.1667 16.6666 11.2733 16.6666 10.1667C16.6666 9.06001 17.5599 8.16668 18.6666 8.16668C19.7733 8.16668 20.6666 9.06001 20.6666 10.1667C20.6666 11.2733 19.7733 12.1667 18.6666 12.1667Z"
            fill="white"
        />
        <path
            d="M18.6666 12.1667C19.7712 12.1667 20.6666 11.2712 20.6666 10.1667C20.6666 9.0621 19.7712 8.16667 18.6666 8.16667C17.5621 8.16667 16.6666 9.0621 16.6666 10.1667C16.6666 11.2712 17.5621 12.1667 18.6666 12.1667Z"
            fill="white"
        />
        <path
            d="M9.33325 12.1667C10.4378 12.1667 11.3333 11.2712 11.3333 10.1667C11.3333 9.0621 10.4378 8.16667 9.33325 8.16667C8.22868 8.16667 7.33325 9.0621 7.33325 10.1667C7.33325 11.2712 8.22868 12.1667 9.33325 12.1667Z"
            fill="white"
        />
        <path
            d="M13.9866 0.166672C6.62663 0.166672 0.666626 6.14001 0.666626 13.5C0.666626 20.86 6.62663 26.8333 13.9866 26.8333C21.36 26.8333 27.3333 20.86 27.3333 13.5C27.3333 6.14001 21.36 0.166672 13.9866 0.166672ZM14 24.1667C8.10663 24.1667 3.33329 19.3933 3.33329 13.5C3.33329 7.60667 8.10663 2.83334 14 2.83334C19.8933 2.83334 24.6666 7.60667 24.6666 13.5C24.6666 19.3933 19.8933 24.1667 14 24.1667Z"
            fill="white"
        />
        <path
            d="M13.9999 21.5C17.0399 21.5 19.6266 19.2867 20.6666 16.1667H7.33325C8.37325 19.2867 10.9599 21.5 13.9999 21.5Z"
            fill="white"
        />
    </svg>
);
export const FinancialsCounterSubCardIcon3 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
        <g clip-path="url(#clip0_2059_5406)">
            <path opacity="0.3" d="M20.7333 15.1667L24.4133 8.5H8.21332L11.3733 15.1667H20.7333Z" fill="white" />
            <path
                d="M20.7333 17.8333C21.7333 17.8333 22.6133 17.2867 23.0666 16.46L27.84 7.80667C28.3333 6.92667 27.6933 5.83334 26.68 5.83334H6.94665L5.69331 3.16667H1.33331V5.83334H3.99998L8.79998 15.9533L6.99998 19.2067C6.02665 20.9933 7.30665 23.1667 9.33331 23.1667H25.3333V20.5H9.33331L10.8 17.8333H20.7333ZM8.21331 8.50001H24.4133L20.7333 15.1667H11.3733L8.21331 8.50001ZM9.33331 24.5C7.86665 24.5 6.67998 25.7 6.67998 27.1667C6.67998 28.6333 7.86665 29.8333 9.33331 29.8333C10.8 29.8333 12 28.6333 12 27.1667C12 25.7 10.8 24.5 9.33331 24.5ZM22.6666 24.5C21.2 24.5 20.0133 25.7 20.0133 27.1667C20.0133 28.6333 21.2 29.8333 22.6666 29.8333C24.1333 29.8333 25.3333 28.6333 25.3333 27.1667C25.3333 25.7 24.1333 24.5 22.6666 24.5Z"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0_2059_5406">
                <rect width="32" height="32" fill="white" transform="translate(0 0.5)" />
            </clipPath>
        </defs>
    </svg>
);

export const HomeIcon = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6.66671 13.3343V9.33431H9.33337V13.3343H12.6667V8.00098H14.6667L8.00004 2.00098L1.33337 8.00098H3.33337V13.3343H6.66671Z"
            fill={'black'}
        />
    </svg>
);

export const UploadIcon = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2324_14350)">
            <path
                d="M12.6666 8.66764C12.4898 8.66764 12.3202 8.73788 12.1952 8.8629C12.0702 8.98793 11.9999 9.1575 11.9999 9.33431V9.58764L11.0133 8.60098C10.6649 8.25534 10.194 8.06139 9.70325 8.06139C9.2125 8.06139 8.74164 8.25534 8.39325 8.60098L7.92659 9.06764L6.27325 7.41431C5.92 7.07805 5.45096 6.8905 4.96325 6.8905C4.47554 6.8905 4.00651 7.07805 3.65325 7.41431L2.66659 8.40098V4.66764C2.66659 4.49083 2.73682 4.32126 2.86185 4.19624C2.98687 4.07121 3.15644 4.00098 3.33325 4.00098H7.99992C8.17673 4.00098 8.3463 3.93074 8.47132 3.80571C8.59635 3.68069 8.66659 3.51112 8.66659 3.33431C8.66659 3.1575 8.59635 2.98793 8.47132 2.86291C8.3463 2.73788 8.17673 2.66764 7.99992 2.66764H3.33325C2.80282 2.66764 2.29411 2.87836 1.91904 3.25343C1.54397 3.6285 1.33325 4.13721 1.33325 4.66764V12.6676C1.33325 13.1981 1.54397 13.7068 1.91904 14.0819C2.29411 14.4569 2.80282 14.6676 3.33325 14.6676H11.3333C11.8637 14.6676 12.3724 14.4569 12.7475 14.0819C13.1225 13.7068 13.3333 13.1981 13.3333 12.6676V9.33431C13.3333 9.1575 13.263 8.98793 13.138 8.8629C13.013 8.73788 12.8434 8.66764 12.6666 8.66764ZM3.33325 13.3343C3.15644 13.3343 2.98687 13.2641 2.86185 13.139C2.73682 13.014 2.66659 12.8445 2.66659 12.6676V10.2876L4.59992 8.35431C4.69786 8.26098 4.82796 8.20891 4.96325 8.20891C5.09854 8.20891 5.22864 8.26098 5.32659 8.35431L7.43992 10.4676L10.3066 13.3343H3.33325ZM11.9999 12.6676C11.999 12.7953 11.9569 12.9192 11.8799 13.021L8.87325 10.001L9.33992 9.53431C9.38771 9.48553 9.44476 9.44677 9.50772 9.42032C9.57069 9.39386 9.63829 9.38023 9.70659 9.38023C9.77488 9.38023 9.84249 9.39386 9.90545 9.42032C9.96841 9.44677 10.0255 9.48553 10.0733 9.53431L11.9999 11.4743V12.6676ZM15.1399 2.86098L13.1399 0.860977C13.0765 0.800283 13.0018 0.752706 12.9199 0.720977C12.7576 0.654298 12.5756 0.654298 12.4133 0.720977C12.3314 0.752706 12.2567 0.800283 12.1933 0.860977L10.1933 2.86098C10.1311 2.92314 10.0818 2.99693 10.0481 3.07814C10.0145 3.15936 9.99719 3.2464 9.99719 3.33431C9.99719 3.51184 10.0677 3.68211 10.1933 3.80764C10.3188 3.93318 10.4891 4.0037 10.6666 4.0037C10.8441 4.0037 11.0144 3.93318 11.1399 3.80764L11.9999 2.94098V6.66764C11.9999 6.84445 12.0702 7.01402 12.1952 7.13905C12.3202 7.26407 12.4898 7.33431 12.6666 7.33431C12.8434 7.33431 13.013 7.26407 13.138 7.13905C13.263 7.01402 13.3333 6.84445 13.3333 6.66764V2.94098L14.1933 3.80764C14.2552 3.87013 14.329 3.91972 14.4102 3.95357C14.4914 3.98742 14.5786 4.00484 14.6666 4.00484C14.7546 4.00484 14.8417 3.98742 14.923 3.95357C15.0042 3.91972 15.0779 3.87013 15.1399 3.80764C15.2024 3.74567 15.252 3.67193 15.2858 3.59069C15.3197 3.50945 15.3371 3.42232 15.3371 3.33431C15.3371 3.2463 15.3197 3.15916 15.2858 3.07793C15.252 2.99669 15.2024 2.92295 15.1399 2.86098V2.86098Z"
                fill={color.primaryMain}
            />
        </g>
        <defs>
            <clipPath id="clip0_2324_14350">
                <rect width="16" height="16" fill="white" transform="translate(0 0.000976562)" />
            </clipPath>
        </defs>
    </svg>
);

export const DropBoxIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill={color.darkPrimaryMain} viewBox="0 0 16 16">
        <path d="M8.01 4.555 4.005 7.11 8.01 9.665 4.005 12.22 0 9.651l4.005-2.555L0 4.555 4.005 2zm-4.026 8.487 4.006-2.555 4.005 2.555-4.005 2.555-4.006-2.555Zm4.026-3.39 4.005-2.556L8.01 4.555 11.995 2 16 4.555 11.995 7.11 16 9.665l-4.005 2.555L8.01 9.651Z" />
    </svg>
);
export const DocumentsFolderIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clip-path="url(#clip0_2398_655)">
            <path
                opacity="0.3"
                d="M11.17 8.00006L10.58 7.41006L9.17 6.00006H4V18.0001H20V8.00006H11.17ZM19 16.0001V17.0001H11V16.0001C11 14.6701 13.67 14.0001 15 14.0001C16.33 14.0001 19 14.6701 19 16.0001ZM15 9.00006C16.1 9.00006 17 9.90006 17 11.0001C17 12.1001 16.1 13.0001 15 13.0001C13.9 13.0001 13 12.1001 13 11.0001C13 9.90006 13.9 9.00006 15 9.00006Z"
                fill={color.grey550}
            />
            <path
                d="M20 6.00006H12L10 4.00006H4C2.9 4.00006 2.01 4.90006 2.01 6.00006L2 18.0001C2 19.1001 2.9 20.0001 4 20.0001H20C21.1 20.0001 22 19.1001 22 18.0001V8.00006C22 6.90006 21.1 6.00006 20 6.00006ZM20 18.0001H4V6.00006H9.17L11.17 8.00006H20V18.0001ZM15 13.0001C16.1 13.0001 17 12.1001 17 11.0001C17 9.90006 16.1 9.00006 15 9.00006C13.9 9.00006 13 9.90006 13 11.0001C13 12.1001 13.9 13.0001 15 13.0001ZM11 16.0001V17.0001H19V16.0001C19 14.6701 16.33 14.0001 15 14.0001C13.67 14.0001 11 14.6701 11 16.0001Z"
                fill={color.grey550}
            />
        </g>
        <defs>
            <clipPath id="clip0_2398_655">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const facebookIcon = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2452_76657)">
            <path
                d="M7 10V14H10V21H14V14H17L18 10H14V8C14 7.73478 14.1054 7.48043 14.2929 7.29289C14.4804 7.10536 14.7348 7 15 7H18V3H15C13.6739 3 12.4021 3.52678 11.4645 4.46447C10.5268 5.40215 10 6.67392 10 8V10H7Z"
                stroke="#757575"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_2452_76657">
                <rect width="24" height="24" fill="white" />{' '}
            </clipPath>
        </defs>
    </svg>
);
export const youtubeIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 20 17" fill="none">
        <path
            d="M15 1.19434H5C2.79086 1.19434 1 3.07707 1 5.39954V11.7073C1 14.0298 2.79086 15.9125 5 15.9125H15C17.2091 15.9125 19 14.0298 19 11.7073V5.39954C19 3.07707 17.2091 1.19434 15 1.19434Z"
            stroke="#757575"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8 5.39954L13 8.55344L8 11.7073V5.39954Z"
            stroke="#757575"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);
export const PlusAddIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
            d="M8 4.66671C7.63333 4.66671 7.33333 4.96671 7.33333 5.33337V7.33337H5.33333C4.96666 7.33337 4.66666 7.63337 4.66666 8.00004C4.66666 8.36671 4.96666 8.66671 5.33333 8.66671H7.33333V10.6667C7.33333 11.0334 7.63333 11.3334 8 11.3334C8.36666 11.3334 8.66666 11.0334 8.66666 10.6667V8.66671H10.6667C11.0333 8.66671 11.3333 8.36671 11.3333 8.00004C11.3333 7.63337 11.0333 7.33337 10.6667 7.33337H8.66666V5.33337C8.66666 4.96671 8.36666 4.66671 8 4.66671ZM8 1.33337C4.32 1.33337 1.33333 4.32004 1.33333 8.00004C1.33333 11.68 4.32 14.6667 8 14.6667C11.68 14.6667 14.6667 11.68 14.6667 8.00004C14.6667 4.32004 11.68 1.33337 8 1.33337ZM8 13.3334C5.06 13.3334 2.66666 10.94 2.66666 8.00004C2.66666 5.06004 5.06 2.66671 8 2.66671C10.94 2.66671 13.3333 5.06004 13.3333 8.00004C13.3333 10.94 10.94 13.3334 8 13.3334Z"
            fill={color.grey550}
        />
        <defs>
            <clipPath id="clip0_2509_634">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
export const PlusAddIconBig = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 16 16" fill="none">
        <path
            d="M8 4.66671C7.63333 4.66671 7.33333 4.96671 7.33333 5.33337V7.33337H5.33333C4.96666 7.33337 4.66666 7.63337 4.66666 8.00004C4.66666 8.36671 4.96666 8.66671 5.33333 8.66671H7.33333V10.6667C7.33333 11.0334 7.63333 11.3334 8 11.3334C8.36666 11.3334 8.66666 11.0334 8.66666 10.6667V8.66671H10.6667C11.0333 8.66671 11.3333 8.36671 11.3333 8.00004C11.3333 7.63337 11.0333 7.33337 10.6667 7.33337H8.66666V5.33337C8.66666 4.96671 8.36666 4.66671 8 4.66671ZM8 1.33337C4.32 1.33337 1.33333 4.32004 1.33333 8.00004C1.33333 11.68 4.32 14.6667 8 14.6667C11.68 14.6667 14.6667 11.68 14.6667 8.00004C14.6667 4.32004 11.68 1.33337 8 1.33337ZM8 13.3334C5.06 13.3334 2.66666 10.94 2.66666 8.00004C2.66666 5.06004 5.06 2.66671 8 2.66671C10.94 2.66671 13.3333 5.06004 13.3333 8.00004C13.3333 10.94 10.94 13.3334 8 13.3334Z"
            fill={color.grey550}
        />
        <defs>
            <clipPath id="clip0_2509_634">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const instagramIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M5 1H15C17.2091 1 19 2.79086 19 5V15C19 17.2091 17.2091 19 15 19H5C2.79086 19 1 17.2091 1 15V5C1 2.79086 2.79086 1 5 1Z"
            stroke="#757575"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M10 13.75C12.0711 13.75 13.75 12.0711 13.75 10C13.75 7.92893 12.0711 6.25 10 6.25C7.92893 6.25 6.25 7.92893 6.25 10C6.25 12.0711 7.92893 13.75 10 13.75Z"
            stroke="#757575"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path d="M15.625 4.375V4.376" stroke="#757575" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
);

export const MultiUserIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12" fill="none">
        <path
            opacity="0.3"
            d="M6.00002 4.66667C6.7364 4.66667 7.33335 4.06971 7.33335 3.33333C7.33335 2.59695 6.7364 2 6.00002 2C5.26364 2 4.66669 2.59695 4.66669 3.33333C4.66669 4.06971 5.26364 4.66667 6.00002 4.66667Z"
            fill={color.grey550}
        />
        <path opacity="0.3" d="M6 8C4.2 8 2.13333 8.86 2 9.34V10H10V9.33333C9.86667 8.86 7.8 8 6 8Z" fill={color.grey550} />
        <path
            d="M11.1133 6.7533C12.0267 7.3733 12.6667 8.2133 12.6667 9.3333V11.3333H15.3333V9.3333C15.3333 7.87996 12.9533 7.01996 11.1133 6.7533Z"
            fill={color.grey550}
        />
        <path
            d="M10 5.99996C11.4733 5.99996 12.6667 4.80663 12.6667 3.33329C12.6667 1.85996 11.4733 0.666626 10 0.666626C9.68668 0.666626 9.39334 0.733292 9.11334 0.826626C9.66668 1.51329 10 2.38663 10 3.33329C10 4.27996 9.66668 5.15329 9.11334 5.83996C9.39334 5.93329 9.68668 5.99996 10 5.99996Z"
            fill={color.grey550}
        />
        <path
            d="M6.00004 5.99996C7.47337 5.99996 8.66671 4.80663 8.66671 3.33329C8.66671 1.85996 7.47337 0.666626 6.00004 0.666626C4.52671 0.666626 3.33337 1.85996 3.33337 3.33329C3.33337 4.80663 4.52671 5.99996 6.00004 5.99996ZM6.00004 1.99996C6.73337 1.99996 7.33337 2.59996 7.33337 3.33329C7.33337 4.06663 6.73337 4.66663 6.00004 4.66663C5.26671 4.66663 4.66671 4.06663 4.66671 3.33329C4.66671 2.59996 5.26671 1.99996 6.00004 1.99996Z"
            fill={color.grey550}
        />
        <path
            d="M6.00002 6.66663C4.22002 6.66663 0.666687 7.55996 0.666687 9.33329V11.3333H11.3334V9.33329C11.3334 7.55996 7.78002 6.66663 6.00002 6.66663ZM10 9.99996H2.00002V9.33996C2.13335 8.85996 4.20002 7.99996 6.00002 7.99996C7.80002 7.99996 9.86669 8.85996 10 9.33329V9.99996Z"
            fill={color.grey550}
        />
    </svg>
);
export const EditIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <g clip-path="url(#clip0_2506_2432)">
            <path
                opacity="0.3"
                d="M3.33333 12.0533V12.6666H3.94666L9.98666 6.62664L9.37333 6.01331L3.33333 12.0533Z"
                fill={color.grey550}
            />
            <path
                d="M13.8067 4.69333C14.0667 4.43333 14.0667 4.01333 13.8067 3.75333L12.2467 2.19333C12.1133 2.06 11.9467 2 11.7733 2C11.6 2 11.4333 2.06667 11.3067 2.19333L10.0867 3.41333L12.5867 5.91333L13.8067 4.69333ZM2 11.5V14H4.5L11.8733 6.62667L9.37333 4.12667L2 11.5ZM3.94667 12.6667H3.33333V12.0533L9.37333 6.01333L9.98667 6.62667L3.94667 12.6667Z"
                fill={color.grey550}
            />
        </g>
        <defs>
            <clipPath id="clip0_2506_2432">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
export const ShareIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <g clip-path="url(#clip0_2506_2438)">
            <path
                opacity="0.3"
                d="M2.66667 5.50002L7.67334 6.16669L2.67334 4.02002L2.66667 5.50002ZM2.67334 11.98L7.67334 9.83335L2.66667 10.5L2.67334 11.98Z"
                fill={color.grey550}
            />
            <path
                d="M1.33999 2L1.33333 6.66667L11.3333 8L1.33333 9.33333L1.33999 14L15.3333 8L1.33999 2ZM2.66666 5.5V4.02L7.67333 6.16667L2.66666 5.5ZM2.67333 11.98V10.5L7.68 9.83333L2.67333 11.98Z"
                fill={color.grey550}
            />
        </g>
        <defs>
            <clipPath id="clip0_2506_2438">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
export const ShareIcon2 = (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <g clip-path="url(#clip0_2506_2438)">
            <path
                opacity="0.3"
                d="M2.66667 5.50002L7.67334 6.16669L2.67334 4.02002L2.66667 5.50002ZM2.67334 11.98L7.67334 9.83335L2.66667 10.5L2.67334 11.98Z"
                fill={color.grey550}
            />
            <path
                d="M1.33999 2L1.33333 6.66667L11.3333 8L1.33333 9.33333L1.33999 14L15.3333 8L1.33999 2ZM2.66666 5.5V4.02L7.67333 6.16667L2.66666 5.5ZM2.67333 11.98V10.5L7.68 9.83333L2.67333 11.98Z"
                fill={color.grey550}
            />
        </g>
        <defs>
            <clipPath id="clip0_2506_2438">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
export const DeleteIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <g clip-path="url(#clip0_2509_947)">
            <path opacity="0.3" d="M5.33333 6H10.6667V12.6667H5.33333V6Z" fill={color.grey550} />
            <path
                d="M10.3333 2.66667L9.66666 2H6.33333L5.66666 2.66667H3.33333V4H12.6667V2.66667H10.3333ZM3.99999 12.6667C3.99999 13.4 4.59999 14 5.33333 14H10.6667C11.4 14 12 13.4 12 12.6667V4.66667H3.99999V12.6667ZM5.33333 6H10.6667V12.6667H5.33333V6Z"
                fill={color.grey550}
            />
        </g>
        <defs>
            <clipPath id="clip0_2509_947">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
export const MoreOptionIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
        <rect opacity="0.1" width="34" height="34" rx="6" fill={color.primaryLight} />
        <rect x="7" y="15" width="4" height="4" rx="2" fill={color.primaryLight} />
        <rect x="15" y="15" width="4" height="4" rx="2" fill={color.primaryLight} />
        <rect x="23" y="15" width="4" height="4" rx="2" fill={color.primaryLight} />
    </svg>
);
export const UserTickIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
            opacity="0.3"
            d="M7.33333 6.66667C8.06971 6.66667 8.66667 6.06971 8.66667 5.33333C8.66667 4.59695 8.06971 4 7.33333 4C6.59695 4 6 4.59695 6 5.33333C6 6.06971 6.59695 6.66667 7.33333 6.66667Z"
            fill={color.grey550}
        />
        <path
            opacity="0.3"
            d="M3.33331 12H6.65998L5.99998 11.3333L6.61998 10.7067C5.03331 10.8867 3.46665 11.58 3.33331 12Z"
            fill={color.grey550}
        />
        <path
            d="M7.33333 7.99996C8.80667 7.99996 10 6.80663 10 5.33329C10 3.85996 8.80667 2.66663 7.33333 2.66663C5.86 2.66663 4.66667 3.85996 4.66667 5.33329C4.66667 6.80663 5.86 7.99996 7.33333 7.99996ZM7.33333 3.99996C8.06667 3.99996 8.66667 4.59996 8.66667 5.33329C8.66667 6.06663 8.06667 6.66663 7.33333 6.66663C6.6 6.66663 6 6.06663 6 5.33329C6 4.59996 6.6 3.99996 7.33333 3.99996ZM6.66667 12H3.33333C3.46667 11.58 5.03333 10.8866 6.62 10.7066H6.64L6.94667 10.4066L8 9.37329C7.74 9.34663 7.54667 9.33329 7.33333 9.33329C5.55333 9.33329 2 10.2266 2 12V13.3333H8L6.66667 12ZM13.7333 8.33329L10.3133 11.78L8.93333 10.3933L8 11.3333L10.3133 13.6666L14.6667 9.27329L13.7333 8.33329Z"
            fill={color.grey550}
        />
    </svg>
);
export const MultiDocumentIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <g clip-path="url(#clip0_2509_639)">
            <path
                opacity="0.3"
                d="M5.33333 10.6666H13.3333V2.66663H5.33333V10.6666ZM6.66666 3.99996H12V5.33329H6.66666V3.99996ZM6.66666 5.99996H12V7.33329H6.66666V5.99996ZM6.66666 7.99996H9.33333V9.33329H6.66666V7.99996Z"
                fill={color.grey550}
            />
            <path
                d="M2.66666 14.6667H12V13.3334H2.66666V4.00004H1.33333V13.3334C1.33333 14.0667 1.93333 14.6667 2.66666 14.6667ZM3.99999 2.66671V10.6667C3.99999 11.4 4.59999 12 5.33333 12H13.3333C14.0667 12 14.6667 11.4 14.6667 10.6667V2.66671C14.6667 1.93337 14.0667 1.33337 13.3333 1.33337H5.33333C4.59999 1.33337 3.99999 1.93337 3.99999 2.66671ZM13.3333 10.6667H5.33333V2.66671H13.3333V10.6667ZM6.66666 6.00004H12V7.33337H6.66666V6.00004ZM6.66666 8.00004H9.33333V9.33337H6.66666V8.00004ZM6.66666 4.00004H12V5.33337H6.66666V4.00004Z"
                fill={color.grey550}
            />
        </g>
        <defs>
            <clipPath id="clip0_2509_639">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
export const PropertyLIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <g clip-path="url(#clip0_2509_237)">
            <path
                opacity="0.3"
                d="M8 7.33333H9.33333V8.66667H8V10H9.33333V11.3333H8V12.6667H13.3333V6H8V7.33333ZM10.6667 7.33333H12V8.66667H10.6667V7.33333ZM10.6667 10H12V11.3333H10.6667V10Z"
                fill={color.grey550}
            />
            <path
                d="M8 4.66667V2H1.33333V14H14.6667V4.66667H8ZM3.99999 12.6667H2.66666V11.3333H3.99999V12.6667ZM3.99999 10H2.66666V8.66667H3.99999V10ZM3.99999 7.33333H2.66666V6H3.99999V7.33333ZM3.99999 4.66667H2.66666V3.33333H3.99999V4.66667ZM6.66666 12.6667H5.33333V11.3333H6.66666V12.6667ZM6.66666 10H5.33333V8.66667H6.66666V10ZM6.66666 7.33333H5.33333V6H6.66666V7.33333ZM6.66666 4.66667H5.33333V3.33333H6.66666V4.66667ZM13.3333 12.6667H8V11.3333H9.33333V10H8V8.66667H9.33333V7.33333H8V6H13.3333V12.6667ZM10.6667 7.33333H12V8.66667H10.6667V7.33333ZM10.6667 10H12V11.3333H10.6667V10Z"
                fill={color.grey550}
            />
        </g>
        <defs>
            <clipPath id="clip0_2509_237">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
export const LocationIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 12 14" fill="none">
        <path
            opacity="0.3"
            d="M6 1.66666C3.76667 1.66666 2 3.37999 2 5.79999C2 7.35999 3.3 9.42666 6 11.8933C8.7 9.42666 10 7.36666 10 5.79999C10 3.37999 8.23333 1.66666 6 1.66666ZM6 6.99999C5.26667 6.99999 4.66667 6.39999 4.66667 5.66666C4.66667 4.93332 5.26667 4.33332 6 4.33332C6.73333 4.33332 7.33333 4.93332 7.33333 5.66666C7.33333 6.39999 6.73333 6.99999 6 6.99999Z"
            fill={color.grey550}
        />
        <path
            d="M6.00008 4.33333C5.26675 4.33333 4.66675 4.93333 4.66675 5.66666C4.66675 6.4 5.26675 7 6.00008 7C6.73341 7 7.33341 6.4 7.33341 5.66666C7.33341 4.93333 6.73341 4.33333 6.00008 4.33333ZM6.00008 0.333328C3.20008 0.333328 0.666748 2.47999 0.666748 5.79999C0.666748 8.01333 2.44675 10.6333 6.00008 13.6667C9.55341 10.6333 11.3334 8.01333 11.3334 5.79999C11.3334 2.47999 8.80008 0.333328 6.00008 0.333328ZM6.00008 11.8867C3.30008 9.42 2.00008 7.35999 2.00008 5.79333C2.00008 3.37999 3.76675 1.66666 6.00008 1.66666C8.23341 1.66666 10.0001 3.37999 10.0001 5.79999C10.0001 7.35999 8.70008 9.42666 6.00008 11.8867Z"
            fill={color.grey550}
        />
    </svg>
);
export const LocationIconBig = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 12 14" fill="none">
        <path
            opacity="0.3"
            d="M6 1.66666C3.76667 1.66666 2 3.37999 2 5.79999C2 7.35999 3.3 9.42666 6 11.8933C8.7 9.42666 10 7.36666 10 5.79999C10 3.37999 8.23333 1.66666 6 1.66666ZM6 6.99999C5.26667 6.99999 4.66667 6.39999 4.66667 5.66666C4.66667 4.93332 5.26667 4.33332 6 4.33332C6.73333 4.33332 7.33333 4.93332 7.33333 5.66666C7.33333 6.39999 6.73333 6.99999 6 6.99999Z"
            fill={color.grey550}
        />
        <path
            d="M6.00008 4.33333C5.26675 4.33333 4.66675 4.93333 4.66675 5.66666C4.66675 6.4 5.26675 7 6.00008 7C6.73341 7 7.33341 6.4 7.33341 5.66666C7.33341 4.93333 6.73341 4.33333 6.00008 4.33333ZM6.00008 0.333328C3.20008 0.333328 0.666748 2.47999 0.666748 5.79999C0.666748 8.01333 2.44675 10.6333 6.00008 13.6667C9.55341 10.6333 11.3334 8.01333 11.3334 5.79999C11.3334 2.47999 8.80008 0.333328 6.00008 0.333328ZM6.00008 11.8867C3.30008 9.42 2.00008 7.35999 2.00008 5.79333C2.00008 3.37999 3.76675 1.66666 6.00008 1.66666C8.23341 1.66666 10.0001 3.37999 10.0001 5.79999C10.0001 7.35999 8.70008 9.42666 6.00008 11.8867Z"
            fill={color.grey550}
        />
    </svg>
);
export const ChartDots = (
    <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M4.5 4.5V28.5H28.5M14.0466 14.6602L17.1666 18.5002M20.6174 18.2709L24.4 12.1563M15.1667 12.5C15.1667 13.9728 13.9728 15.1667 12.5 15.1667C11.0272 15.1667 9.83333 13.9728 9.83333 12.5C9.83333 11.0272 11.0272 9.83333 12.5 9.83333C13.9728 9.83333 15.1667 11.0272 15.1667 12.5ZM28.5 9.83333C28.5 11.3061 27.3061 12.5 25.8333 12.5C24.3606 12.5 23.1667 11.3061 23.1667 9.83333C23.1667 8.36057 24.3606 7.16667 25.8333 7.16667C27.3061 7.16667 28.5 8.36057 28.5 9.83333ZM21.8333 20.5C21.8333 21.9728 20.6394 23.1667 19.1667 23.1667C17.6939 23.1667 16.5 21.9728 16.5 20.5C16.5 19.0272 17.6939 17.8333 19.1667 17.8333C20.6394 17.8333 21.8333 19.0272 21.8333 20.5Z"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);

export const UserTick = (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.00146 9C9.2106 9 11.0015 7.20914 11.0015 5C11.0015 2.79086 9.2106 1 7.00146 1C4.79233 1 3.00146 2.79086 3.00146 5C3.00146 7.20914 4.79233 9 7.00146 9Z"
            stroke={color.grey550}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M1 19V17C1 15.9392 1.42143 14.9217 2.17157 14.1716C2.92172 13.4215 3.93913 13 5 13H9C10.0609 13 11.0783 13.4215 11.8284 14.1716C12.5786 14.9217 13 15.9392 13 17V19"
            stroke={color.grey550}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M13.999 9.00002L15.999 11L19.999 7.00002"
            stroke={color.grey550}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);
export const FinancialsMoneySymbol = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <g clip-path="url(#clip0_2774_49572)">
            <path
                opacity="0.3"
                d="M8.00008 2.66666C5.06008 2.66666 2.66675 5.06 2.66675 8C2.66675 10.94 5.06008 13.3333 8.00008 13.3333C10.9401 13.3333 13.3334 10.94 13.3334 8C13.3334 5.06 10.9401 2.66666 8.00008 2.66666ZM8.82008 11.5533V12.6667H7.26675V11.54C6.26675 11.3333 5.42008 10.6867 5.36008 9.56H6.50008C6.56008 10.1733 6.98008 10.6533 8.04675 10.6533C9.18675 10.6533 9.44675 10.08 9.44675 9.72666C9.44675 9.24 9.18675 8.78666 7.88675 8.48C6.44008 8.12666 5.44675 7.53333 5.44675 6.34C5.44675 5.33333 6.26008 4.68666 7.26008 4.46666V3.33333H8.82008V4.47333C9.90675 4.73333 10.4467 5.56 10.4801 6.45333H9.34008C9.31341 5.80666 8.96675 5.36 8.04675 5.36C7.17341 5.36 6.64675 5.75333 6.64675 6.31333C6.64675 6.8 7.02675 7.12666 8.20675 7.42666C9.38675 7.73333 10.6467 8.24 10.6467 9.70666C10.6401 10.7733 9.84008 11.36 8.82008 11.5533V11.5533Z"
                fill={color.grey550}
            />
            <path
                d="M7.99992 1.33334C4.31992 1.33334 1.33325 4.32 1.33325 8C1.33325 11.68 4.31992 14.6667 7.99992 14.6667C11.6799 14.6667 14.6666 11.68 14.6666 8C14.6666 4.32 11.6799 1.33334 7.99992 1.33334ZM7.99992 13.3333C5.05992 13.3333 2.66659 10.94 2.66659 8C2.66659 5.06 5.05992 2.66667 7.99992 2.66667C10.9399 2.66667 13.3333 5.06 13.3333 8C13.3333 10.94 10.9399 13.3333 7.99992 13.3333ZM8.20659 7.42667C7.02659 7.12667 6.64659 6.8 6.64659 6.31334C6.64659 5.75334 7.17325 5.36 8.04659 5.36C8.96659 5.36 9.31325 5.8 9.33992 6.45334H10.4799C10.4466 5.56 9.89992 4.74 8.81992 4.47334V3.33334H7.26659V4.46C6.25992 4.67334 5.45325 5.32667 5.45325 6.33334C5.45325 7.52667 6.44659 8.12667 7.89325 8.47334C9.19325 8.78 9.45325 9.24 9.45325 9.72C9.45325 10.0733 9.19325 10.6467 8.05325 10.6467C6.98659 10.6467 6.56659 10.1667 6.50659 9.55334H5.35992C5.42659 10.6867 6.26659 11.3267 7.26659 11.5333V12.6667H8.82659V11.5533C9.83992 11.36 10.6399 10.78 10.6466 9.70667C10.6399 8.24 9.37992 7.73334 8.20659 7.42667V7.42667Z"
                fill={color.grey550}
            />
        </g>
        <defs>
            <clipPath id="clip0_2774_49572">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const FinancialsCardIcon1 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none">
        <g clip-path="url(#clip0_2788_1858)">
            <path
                opacity="0.3"
                d="M7.29175 7.29166V27.7083H27.7084V7.29166H7.29175ZM13.1251 24.7917H10.2084V14.5833H13.1251V24.7917ZM18.9584 24.7917H16.0417V10.2083H18.9584V24.7917ZM24.7917 24.7917H21.8751V18.9583H24.7917V24.7917Z"
                fill={color.primaryMain}
            />
            <path
                d="M27.7083 4.375H7.29167C5.6875 4.375 4.375 5.6875 4.375 7.29167V27.7083C4.375 29.3125 5.6875 30.625 7.29167 30.625H27.7083C29.3125 30.625 30.625 29.3125 30.625 27.7083V7.29167C30.625 5.6875 29.3125 4.375 27.7083 4.375ZM27.7083 27.7083H7.29167V7.29167H27.7083V27.7083ZM10.2083 14.5833H13.125V24.7917H10.2083V14.5833ZM16.0417 10.2083H18.9583V24.7917H16.0417V10.2083ZM21.875 18.9583H24.7917V24.7917H21.875V18.9583Z"
                fill={color.primaryMain}
            />
        </g>
        <defs>
            <clipPath id="clip0_2788_1858">
                <rect width="35" height="35" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
export const FinancialsCardIcon2 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none">
        <path
            d="M4.375 4.375V30.625H30.625M14.8166 15.4877L18.2291 19.6877M22.0034 19.4369L26.1406 12.749M16.0417 13.125C16.0417 14.7358 14.7358 16.0417 13.125 16.0417C11.5142 16.0417 10.2083 14.7358 10.2083 13.125C10.2083 11.5142 11.5142 10.2083 13.125 10.2083C14.7358 10.2083 16.0417 11.5142 16.0417 13.125ZM30.625 10.2083C30.625 11.8192 29.3192 13.125 27.7083 13.125C26.0975 13.125 24.7917 11.8192 24.7917 10.2083C24.7917 8.5975 26.0975 7.29167 27.7083 7.29167C29.3192 7.29167 30.625 8.5975 30.625 10.2083ZM23.3333 21.875C23.3333 23.4858 22.0275 24.7917 20.4167 24.7917C18.8058 24.7917 17.5 23.4858 17.5 21.875C17.5 20.2642 18.8058 18.9583 20.4167 18.9583C22.0275 18.9583 23.3333 20.2642 23.3333 21.875Z"
            stroke={color.primaryDark}
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);
export const FinancialsCardIcon3 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="27" height="31" viewBox="0 0 27 31" fill="none">
        <path
            opacity="0.4"
            d="M19.6119 0.916656H7.38958C2.95625 0.916656 0.375 3.51249 0.375 7.96041V23.025C0.375 27.5458 2.95625 30.0833 7.38958 30.0833H19.6119C24.1167 30.0833 26.625 27.5458 26.625 23.025V7.96041C26.625 3.51249 24.1167 0.916656 19.6119 0.916656"
            fill={color.primaryMain}
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.7834 7.69791V7.71249C7.15486 7.71249 6.6459 8.22291 6.6459 8.84999C6.6459 9.47707 7.15486 9.98749 7.7834 9.98749H12.1424C12.7709 9.98749 13.2813 9.47707 13.2813 8.83395C13.2813 8.20832 12.7709 7.69791 12.1424 7.69791H7.7834ZM19.2167 16.5792H7.7834C7.15486 16.5792 6.6459 16.0687 6.6459 15.4417C6.6459 14.8146 7.15486 14.3027 7.7834 14.3027H19.2167C19.8438 14.3027 20.3542 14.8146 20.3542 15.4417C20.3542 16.0687 19.8438 16.5792 19.2167 16.5792ZM19.2167 23.2437H7.7834C7.3459 23.3021 6.92298 23.0833 6.68965 22.7187C6.45632 22.3396 6.45632 21.8583 6.68965 21.4937C6.92298 21.1146 7.3459 20.9104 7.7834 20.9542H19.2167C19.7986 21.0125 20.2376 21.5083 20.2376 22.1062C20.2376 22.6881 19.7986 23.1854 19.2167 23.2437Z"
            fill={color.primaryMain}
        />
    </svg>
);
export const FinancialsCardIcon4 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none">
        <g clip-path="url(#clip0_2788_1871)">
            <path
                opacity="0.3"
                d="M14.3354 11.6667H16.0417V20.4167H18.9584V11.6667H20.6646L17.5 8.50208L14.3354 11.6667Z"
                fill={color.primaryMain}
            />
            <path
                d="M17.5001 4.375L7.29175 14.5833H13.1251V23.3333H21.8751V14.5833H27.7084L17.5001 4.375ZM18.9584 11.6667V20.4167H16.0417V11.6667H14.3355L17.5001 8.50208L20.6647 11.6667H18.9584ZM7.29175 26.25H27.7084V29.1667H7.29175V26.25Z"
                fill={color.primaryDark}
            />
        </g>
        <defs>
            <clipPath id="clip0_2788_1871">
                <rect width="35" height="35" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
export const FinancialsCardIcon5 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none">
        <path
            d="M1.45825 30.625H33.5416L17.4999 2.91666L1.45825 30.625ZM18.9583 26.25H16.0416V23.3333H18.9583V26.25ZM18.9583 20.4167H16.0416V14.5833H18.9583V20.4167Z"
            fill={color.primaryMain}
        />
    </svg>
);
export const FinancialsCardIcon6 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none">
        <path
            d="M17.5001 2.91666C9.47925 2.91666 2.91675 9.47916 2.91675 17.5C2.91675 25.5208 9.47925 32.0833 17.5001 32.0833C25.5209 32.0833 32.0834 25.5208 32.0834 17.5C32.0834 9.47916 25.5209 2.91666 17.5001 2.91666ZM23.6251 15.0208L16.6251 22.0208C16.0417 22.6042 15.1667 22.6042 14.5834 22.0208L11.3751 18.8125C10.7917 18.2292 10.7917 17.3542 11.3751 16.7708C11.9584 16.1875 12.8334 16.1875 13.4167 16.7708L15.6042 18.9583L21.5834 12.9792C22.1667 12.3958 23.0417 12.3958 23.6251 12.9792C24.2084 13.5625 24.2084 14.4375 23.6251 15.0208Z"
            fill={color.primaryMedium}
        />
    </svg>
);
export const FinancialsCardIcon7 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="25" viewBox="0 0 33 25" fill="none">
        <path
            opacity="0.3"
            d="M12.1249 9.58333C13.7357 9.58333 15.0416 8.2775 15.0416 6.66667C15.0416 5.05584 13.7357 3.75 12.1249 3.75C10.5141 3.75 9.20825 5.05584 9.20825 6.66667C9.20825 8.2775 10.5141 9.58333 12.1249 9.58333Z"
            fill={color.primaryLight}
        />
        <path
            opacity="0.3"
            d="M12.125 16.875C8.1875 16.875 3.66667 18.7563 3.375 19.8063V21.25H20.875V19.7917C20.5833 18.7563 16.0625 16.875 12.125 16.875Z"
            fill={color.primaryLight}
        />
        <path
            d="M23.3103 14.1479C25.3082 15.5042 26.7082 17.3417 26.7082 19.7917V24.1667H32.5416V19.7917C32.5416 16.6125 27.3353 14.7313 23.3103 14.1479Z"
            fill={color.primaryDark}
        />
        <path
            d="M20.8749 12.5C24.0978 12.5 26.7082 9.88959 26.7082 6.66668C26.7082 3.44376 24.0978 0.833344 20.8749 0.833344C20.1895 0.833344 19.5478 0.979176 18.9353 1.18334C20.1457 2.68543 20.8749 4.59584 20.8749 6.66668C20.8749 8.73751 20.1457 10.6479 18.9353 12.15C19.5478 12.3542 20.1895 12.5 20.8749 12.5Z"
            fill={color.primaryDark}
        />
        <path
            d="M12.1248 12.5C15.3478 12.5 17.9582 9.88959 17.9582 6.66668C17.9582 3.44376 15.3478 0.833344 12.1248 0.833344C8.90192 0.833344 6.2915 3.44376 6.2915 6.66668C6.2915 9.88959 8.90192 12.5 12.1248 12.5ZM12.1248 3.75001C13.729 3.75001 15.0415 5.06251 15.0415 6.66668C15.0415 8.27084 13.729 9.58334 12.1248 9.58334C10.5207 9.58334 9.20817 8.27084 9.20817 6.66668C9.20817 5.06251 10.5207 3.75001 12.1248 3.75001Z"
            fill={color.primaryDark}
        />
        <path
            d="M12.1249 13.9583C8.23117 13.9583 0.458252 15.9125 0.458252 19.7917V24.1667H23.7916V19.7917C23.7916 15.9125 16.0187 13.9583 12.1249 13.9583ZM20.8749 21.25H3.37492V19.8063C3.66659 18.7563 8.18742 16.875 12.1249 16.875C16.0624 16.875 20.5833 18.7563 20.8749 19.7917V21.25Z"
            fill={color.primaryDark}
        />
    </svg>
);
export const FinancialsCardIcon8 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none">
        <g clip-path="url(#clip0_2788_1496)">
            <path opacity="0.3" d="M22.6771 16.0417L26.7021 8.75H8.9834L12.4396 16.0417H22.6771Z" fill={color.primaryMain} />
            <path
                d="M22.677 18.9583C23.7708 18.9583 24.7333 18.3604 25.2291 17.4562L30.4499 7.99166C30.9895 7.02916 30.2895 5.83332 29.1812 5.83332H7.59784L6.227 2.91666H1.45825V5.83332H4.37492L9.62492 16.9021L7.65617 20.4604C6.59159 22.4146 7.99159 24.7917 10.2083 24.7917H27.7083V21.875H10.2083L11.8124 18.9583H22.677ZM8.98325 8.74999H26.702L22.677 16.0417H12.4395L8.98325 8.74999ZM10.2083 26.25C8.60409 26.25 7.30617 27.5625 7.30617 29.1667C7.30617 30.7708 8.60409 32.0833 10.2083 32.0833C11.8124 32.0833 13.1249 30.7708 13.1249 29.1667C13.1249 27.5625 11.8124 26.25 10.2083 26.25ZM24.7916 26.25C23.1874 26.25 21.8895 27.5625 21.8895 29.1667C21.8895 30.7708 23.1874 32.0833 24.7916 32.0833C26.3958 32.0833 27.7083 30.7708 27.7083 29.1667C27.7083 27.5625 26.3958 26.25 24.7916 26.25Z"
                fill={color.primaryMain}
            />
        </g>
        <defs>
            <clipPath id="clip0_2788_1496">
                <rect width="35" height="35" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
export const TimelineIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            d="M19 4H5C4.44772 4 4 4.44771 4 5V7C4 7.55228 4.44772 8 5 8H19C19.5523 8 20 7.55228 20 7V5C20 4.44771 19.5523 4 19 4Z"
            stroke={color.grey550}
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M9 12H5C4.44772 12 4 12.4477 4 13V19C4 19.5523 4.44772 20 5 20H9C9.55228 20 10 19.5523 10 19V13C10 12.4477 9.55228 12 9 12Z"
            stroke={color.grey550}
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path d="M14 12H20" stroke={color.grey550} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M14 16H20" stroke={color.grey550} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M14 20H20" stroke={color.grey550} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
);
export const ClientsPaymentIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
        <g clip-path="url(#clip0_3767_848)">
            <path d="M0 0H22V22H0V0Z" fill={color.primaryDark} />
            <path
                opacity="0.3"
                d="M4.58331 4.58337V17.4167H17.4166V4.58337H4.58331ZM8.24998 15.5834H6.41665V9.16671H8.24998V15.5834ZM11.9166 15.5834H10.0833V6.41671H11.9166V15.5834ZM15.5833 15.5834H13.75V11.9167H15.5833V15.5834Z"
                fill="white"
            />
            <path
                d="M17.4167 2.75H4.58333C3.575 2.75 2.75 3.575 2.75 4.58333V17.4167C2.75 18.425 3.575 19.25 4.58333 19.25H17.4167C18.425 19.25 19.25 18.425 19.25 17.4167V4.58333C19.25 3.575 18.425 2.75 17.4167 2.75ZM17.4167 17.4167H4.58333V4.58333H17.4167V17.4167ZM6.41667 9.16667H8.25V15.5833H6.41667V9.16667ZM10.0833 6.41667H11.9167V15.5833H10.0833V6.41667ZM13.75 11.9167H15.5833V15.5833H13.75V11.9167Z"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0_3767_848">
                <rect width="22" height="22" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
export const ClientsViewShareIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <g clip-path="url(#clip0_3767_281)">
            <path
                opacity="0.3"
                d="M12 3.99996C12.3682 3.99996 12.6667 3.70148 12.6667 3.33329C12.6667 2.9651 12.3682 2.66663 12 2.66663C11.6319 2.66663 11.3334 2.9651 11.3334 3.33329C11.3334 3.70148 11.6319 3.99996 12 3.99996Z"
                fill={color.grey550}
            />
            <path
                opacity="0.3"
                d="M12 3.99996C12.3682 3.99996 12.6667 3.70148 12.6667 3.33329C12.6667 2.9651 12.3682 2.66663 12 2.66663C11.6319 2.66663 11.3334 2.9651 11.3334 3.33329C11.3334 3.70148 11.6319 3.99996 12 3.99996Z"
                fill={color.grey550}
            />
            <path
                opacity="0.3"
                d="M4.00004 8.66671C4.36823 8.66671 4.66671 8.36823 4.66671 8.00004C4.66671 7.63185 4.36823 7.33337 4.00004 7.33337C3.63185 7.33337 3.33337 7.63185 3.33337 8.00004C3.33337 8.36823 3.63185 8.66671 4.00004 8.66671Z"
                fill={color.grey550}
            />
            <path
                opacity="0.3"
                d="M4.00004 8.66671C4.36823 8.66671 4.66671 8.36823 4.66671 8.00004C4.66671 7.63185 4.36823 7.33337 4.00004 7.33337C3.63185 7.33337 3.33337 7.63185 3.33337 8.00004C3.33337 8.36823 3.63185 8.66671 4.00004 8.66671Z"
                fill={color.grey550}
            />
            <path
                opacity="0.3"
                d="M12 13.3466C12.3682 13.3466 12.6667 13.0482 12.6667 12.68C12.6667 12.3118 12.3682 12.0133 12 12.0133C11.6319 12.0133 11.3334 12.3118 11.3334 12.68C11.3334 13.0482 11.6319 13.3466 12 13.3466Z"
                fill={color.grey550}
            />
            <path
                opacity="0.3"
                d="M12 13.3466C12.3682 13.3466 12.6667 13.0482 12.6667 12.68C12.6667 12.3118 12.3682 12.0133 12 12.0133C11.6319 12.0133 11.3334 12.3118 11.3334 12.68C11.3334 13.0482 11.6319 13.3466 12 13.3466Z"
                fill={color.grey550}
            />
            <path
                d="M12 10.72C11.4933 10.72 11.04 10.92 10.6933 11.2334L5.94 8.46671C5.97333 8.31337 6 8.16004 6 8.00004C6 7.84004 5.97333 7.68671 5.94 7.53337L10.64 4.79337C11 5.12671 11.4733 5.33337 12 5.33337C13.1067 5.33337 14 4.44004 14 3.33337C14 2.22671 13.1067 1.33337 12 1.33337C10.8933 1.33337 10 2.22671 10 3.33337C10 3.49337 10.0267 3.64671 10.06 3.80004L5.36 6.54004C5 6.20671 4.52667 6.00004 4 6.00004C2.89333 6.00004 2 6.89337 2 8.00004C2 9.10671 2.89333 10 4 10C4.52667 10 5 9.79337 5.36 9.46004L10.1067 12.2334C10.0733 12.3734 10.0533 12.52 10.0533 12.6667C10.0533 13.74 10.9267 14.6134 12 14.6134C13.0733 14.6134 13.9467 13.74 13.9467 12.6667C13.9467 11.5934 13.0733 10.72 12 10.72ZM12 2.66671C12.3667 2.66671 12.6667 2.96671 12.6667 3.33337C12.6667 3.70004 12.3667 4.00004 12 4.00004C11.6333 4.00004 11.3333 3.70004 11.3333 3.33337C11.3333 2.96671 11.6333 2.66671 12 2.66671ZM4 8.66671C3.63333 8.66671 3.33333 8.36671 3.33333 8.00004C3.33333 7.63337 3.63333 7.33337 4 7.33337C4.36667 7.33337 4.66667 7.63337 4.66667 8.00004C4.66667 8.36671 4.36667 8.66671 4 8.66671ZM12 13.3467C11.6333 13.3467 11.3333 13.0467 11.3333 12.68C11.3333 12.3134 11.6333 12.0134 12 12.0134C12.3667 12.0134 12.6667 12.3134 12.6667 12.68C12.6667 13.0467 12.3667 13.3467 12 13.3467Z"
                fill={color.grey550}
            />
            <path
                d="M12 10.72C11.4933 10.72 11.04 10.92 10.6933 11.2334L5.94 8.46671C5.97333 8.31337 6 8.16004 6 8.00004C6 7.84004 5.97333 7.68671 5.94 7.53337L10.64 4.79337C11 5.12671 11.4733 5.33337 12 5.33337C13.1067 5.33337 14 4.44004 14 3.33337C14 2.22671 13.1067 1.33337 12 1.33337C10.8933 1.33337 10 2.22671 10 3.33337C10 3.49337 10.0267 3.64671 10.06 3.80004L5.36 6.54004C5 6.20671 4.52667 6.00004 4 6.00004C2.89333 6.00004 2 6.89337 2 8.00004C2 9.10671 2.89333 10 4 10C4.52667 10 5 9.79337 5.36 9.46004L10.1067 12.2334C10.0733 12.3734 10.0533 12.52 10.0533 12.6667C10.0533 13.74 10.9267 14.6134 12 14.6134C13.0733 14.6134 13.9467 13.74 13.9467 12.6667C13.9467 11.5934 13.0733 10.72 12 10.72ZM12 2.66671C12.3667 2.66671 12.6667 2.96671 12.6667 3.33337C12.6667 3.70004 12.3667 4.00004 12 4.00004C11.6333 4.00004 11.3333 3.70004 11.3333 3.33337C11.3333 2.96671 11.6333 2.66671 12 2.66671ZM4 8.66671C3.63333 8.66671 3.33333 8.36671 3.33333 8.00004C3.33333 7.63337 3.63333 7.33337 4 7.33337C4.36667 7.33337 4.66667 7.63337 4.66667 8.00004C4.66667 8.36671 4.36667 8.66671 4 8.66671ZM12 13.3467C11.6333 13.3467 11.3333 13.0467 11.3333 12.68C11.3333 12.3134 11.6333 12.0134 12 12.0134C12.3667 12.0134 12.6667 12.3134 12.6667 12.68C12.6667 13.0467 12.3667 13.3467 12 13.3467Z"
                fill={color.grey550}
            />
        </g>
        <defs>
            <clipPath id="clip0_3767_281">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const DashboardAgenciesIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="18" viewBox="0 0 22 18" fill="none">
        <path
            d="M21.0439 5.89L19.939 1.52C19.7075 0.62 18.8868 0 17.9293 0H15.6038H13.4889H11.679H9.57455H7.76471H5.6392H3.31377C2.36676 0 1.5355 0.63 1.31453 1.52L0.209687 5.89C-0.0428488 6.91 0.188642 7.95 0.862071 8.77C0.946249 8.88 1.06199 8.96 1.1567 9.06V16C1.1567 17.1 2.1037 18 3.26116 18H17.9924C19.1499 18 20.0969 17.1 20.0969 16V9.06C20.1916 8.97 20.3073 8.88 20.3915 8.78C21.0649 7.96 21.3069 6.91 21.0439 5.89ZM5.38667 2L4.77637 6.86C4.6922 7.51 4.14503 8 3.50317 8C2.98758 8 2.66139 7.71 2.5246 7.53C2.25102 7.2 2.15632 6.77 2.26154 6.36L3.31377 2H5.38667ZM17.8977 1.99L19.0026 6.36C19.1078 6.78 19.0131 7.2 18.7395 7.53C18.5922 7.71 18.2765 8 17.7504 8C17.1085 8 16.5508 7.51 16.4772 6.86L15.8669 2L17.8977 1.99ZM14.3201 6.52C14.3727 6.91 14.2465 7.3 13.9729 7.59C13.7309 7.85 13.3942 8 12.9627 8C12.2577 8 11.679 7.41 11.679 6.69V2H13.7414L14.3201 6.52ZM9.57455 6.69C9.57455 7.41 8.99582 8 8.21717 8C7.85941 8 7.53322 7.85 7.28069 7.59C7.01763 7.3 6.89136 6.91 6.93345 6.52L7.51218 2H9.57455V6.69ZM16.9402 16H4.31339C3.73466 16 3.26116 15.55 3.26116 15V9.97C3.34534 9.98 3.41899 10 3.50317 10C4.41862 10 5.24988 9.64 5.86017 9.05C6.49151 9.65 7.3333 10 8.29083 10C9.20627 10 10.027 9.64 10.6373 9.07C11.2581 9.64 12.0999 10 13.0469 10C13.9308 10 14.7726 9.65 15.4039 9.05C16.0142 9.64 16.8455 10 17.7609 10C17.8451 10 17.9188 9.98 18.0029 9.97V15C17.9924 15.55 17.5189 16 16.9402 16Z"
            fill="white"
        />
    </svg>
);

export const DashboardAgentsIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24" fill="none">
        <path
            opacity="0.3"
            d="M11.7605 10C12.9016 10 13.8267 9.10457 13.8267 8C13.8267 6.89543 12.9016 6 11.7605 6C10.6193 6 9.69424 6.89543 9.69424 8C9.69424 9.10457 10.6193 10 11.7605 10Z"
            fill="#616161"
        />
        <path
            opacity="0.3"
            d="M5.5618 18.0001H10.717L9.69426 17.0001L10.6551 16.0601C8.19624 16.3301 5.76842 17.3701 5.5618 18.0001Z"
            fill="#616161"
        />
        <path
            d="M11.7605 12C14.0437 12 15.8929 10.21 15.8929 8C15.8929 5.79 14.0437 4 11.7605 4C9.47728 4 7.62801 5.79 7.62801 8C7.62801 10.21 9.47728 12 11.7605 12ZM11.7605 6C12.8969 6 13.8267 6.9 13.8267 8C13.8267 9.1 12.8969 10 11.7605 10C10.624 10 9.69424 9.1 9.69424 8C9.69424 6.9 10.624 6 11.7605 6ZM10.7274 18H5.56178C5.7684 17.37 8.19622 16.33 10.655 16.06H10.686L11.1613 15.61L12.7936 14.06C12.3907 14.02 12.0911 14 11.7605 14C9.00205 14 3.49554 15.34 3.49554 18V20H12.7936L10.7274 18ZM21.6784 12.5L16.3785 17.67L14.2399 15.59L12.7936 17L16.3785 20.5L23.1247 13.91L21.6784 12.5Z"
            fill="#F8F5F2"
        />
    </svg>
);
export const DashboardUpdatesIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24" fill="none">
        <g clip-path="url(#clip0_4552_1137)">
            <path
                d="M21.0446 3H19.9924V1H17.8879V3H7.36562V1H5.26116V3H4.20893C3.05147 3 2.10446 3.9 2.10446 5V21C2.10446 22.1 3.05147 23 4.20893 23H21.0446C22.2021 23 23.1491 22.1 23.1491 21V5C23.1491 3.9 22.2021 3 21.0446 3ZM21.0446 5V8H4.20893V5H21.0446ZM4.20893 21V10H21.0446V21H4.20893Z"
                fill="#F8F5F2"
            />
            <path opacity="0.3" d="M4.20893 5.01001H21.0446V8.00001H4.20893V5.01001Z" fill="white" />
        </g>
        <defs>
            <clipPath id="clip0_4552_1137">
                <rect width="25.2536" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const NotificationSystemIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
        <g clip-path="url(#clip0_4871_142628)">
            <path
                d="M14.1373 7.42317L14.4055 7.02089C14.8795 7.98653 15.1116 9.05757 15.0756 10.1407C15.0336 11.4052 14.6282 12.6289 13.9106 13.6666H3.08917C2.25842 12.4675 1.84816 11.0239 1.92714 9.56255C2.01056 8.01896 2.63451 6.55396 3.68966 5.42422C4.74481 4.29449 6.16385 3.5721 7.69816 3.38361C8.97235 3.22708 10.2585 3.44706 11.401 4.00769L10.9932 4.27953C9.87471 3.78523 8.6321 3.63377 7.42366 3.84811C6.11843 4.07963 4.92254 4.72558 4.01329 5.6902C3.10404 6.65482 2.52983 7.88676 2.37578 9.20338C2.22173 10.52 2.49605 11.8512 3.15807 12.9997L3.30235 13.25H3.59125H13.4088H13.6977L13.842 12.9996C14.3513 12.1157 14.6334 11.1193 14.663 10.0995C14.6898 9.17812 14.5096 8.26372 14.1373 7.42317Z"
                fill="white"
                stroke="#5B4933"
            />
            <path
                d="M7.85499 10.562L7.8546 10.5616C7.76937 10.4765 7.70176 10.3754 7.65563 10.2641C7.6095 10.1528 7.58575 10.0335 7.58575 9.91307C7.58575 9.79261 7.6095 9.67332 7.65563 9.56204C7.69613 9.46435 7.75318 9.3745 7.82418 9.29641L11.7122 6.70439L9.12019 10.5924C9.04211 10.6634 8.95226 10.7205 8.85457 10.761C8.74328 10.8071 8.624 10.8309 8.50354 10.8309C8.38307 10.8309 8.26379 10.8071 8.15251 10.761C8.04123 10.7148 7.94013 10.6472 7.85499 10.562Z"
                fill="#F8F5F2"
                stroke="#5B4933"
            />
        </g>
        <defs>
            <clipPath id="clip0_4871_142628">
                <rect width="17" height="17" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const ClipAttachmentsIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Earth" clip-path="url(#clip0_4552_249900)">
            <path
                id="Vector"
                d="M18.5 16H7C4.79 16 3 14.21 3 12C3 9.79 4.79 8 7 8H19.5C20.88 8 22 9.12 22 10.5C22 11.88 20.88 13 19.5 13H9C8.45 13 8 12.55 8 12C8 11.45 8.45 11 9 11H18.5V9.5H9C7.62 9.5 6.5 10.62 6.5 12C6.5 13.38 7.62 14.5 9 14.5H19.5C21.71 14.5 23.5 12.71 23.5 10.5C23.5 8.29 21.71 6.5 19.5 6.5H7C3.96 6.5 1.5 8.96 1.5 12C1.5 15.04 3.96 17.5 7 17.5H18.5V16Z"
                fill="#757575"
            />
        </g>
        <defs>
            <clipPath id="clip0_4552_249900">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const StairChartGraph = (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
        <path
            d="M4.75018 20H8.63782V16H12.5255V12H16.4131V8H20.3007M4.75018 11L11.5535 4M11.5535 4V8M11.5535 4H7.66591"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);

export const ChartTime = (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
        <path
            d="M11.5535 7C11.5535 9.20914 9.81298 11 7.66589 11C5.51881 11 3.77826 9.20914 3.77826 7C3.77826 4.79086 5.51881 3 7.66589 3M11.5535 7C11.5535 4.79086 9.81298 3 7.66589 3M11.5535 7H7.66589V3M9.60971 17V21M17.385 14V21M13.4973 13V21M21.2726 12V21"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);
export const ProfileLocation = (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Location">
            <g id="Group">
                <g id="Group_2">
                    <path
                        id="Vector"
                        opacity="0.3"
                        d="M12.5254 4C9.26953 4 6.69397 6.57 6.69397 10.2C6.69397 12.54 8.58919 15.64 12.5254 19.34C16.4617 15.64 18.3569 12.55 18.3569 10.2C18.3569 6.57 15.7813 4 12.5254 4ZM12.5254 12C11.4563 12 10.5816 11.1 10.5816 10C10.5816 8.9 11.4563 8 12.5254 8C13.5945 8 14.4692 8.9 14.4692 10C14.4692 11.1 13.5945 12 12.5254 12Z"
                        fill="white"
                    />
                    <path
                        id="Vector_2"
                        d="M12.5254 8C11.4563 8 10.5816 8.9 10.5816 10C10.5816 11.1 11.4563 12 12.5254 12C13.5945 12 14.4692 11.1 14.4692 10C14.4692 8.9 13.5945 8 12.5254 8ZM12.5254 2C8.44341 2 4.75015 5.22 4.75015 10.2C4.75015 13.52 7.34515 17.45 12.5254 22C17.7057 17.45 20.3007 13.52 20.3007 10.2C20.3007 5.22 16.6074 2 12.5254 2ZM12.5254 19.33C8.58919 15.63 6.69397 12.54 6.69397 10.19C6.69397 6.57 9.26953 4 12.5254 4C15.7813 4 18.3569 6.57 18.3569 10.2C18.3569 12.54 16.4617 15.64 12.5254 19.33Z"
                        fill="white"
                    />
                </g>
            </g>
        </g>
    </svg>
);

export const ArchitecturalApprovalIcon = (
    <svg width="37" height="36" viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" width="36" height="36" rx="18" fill="#5B4933" />
        <g clip-path="url(#clip0_5696_10957)">
            <path d="M28.5 8H8.5V28H28.5V8Z" fill="#5B4933" />
            <path
                d="M22.6667 17.1667V12.1667C22.6667 11.25 21.9167 10.5 21 10.5H16C15.0833 10.5 14.3333 11.25 14.3333 12.1667V13.8333H12.6667C11.75 13.8333 11 14.5833 11 15.5V23.8333C11 24.75 11.75 25.5 12.6667 25.5H16.8333C17.2917 25.5 17.6667 25.125 17.6667 24.6667V22.1667H19.3333V24.6667C19.3333 25.125 19.7083 25.5 20.1667 25.5H24.3333C25.25 25.5 26 24.75 26 23.8333V18.8333C26 17.9167 25.25 17.1667 24.3333 17.1667H22.6667ZM14.3333 23.8333H12.6667V22.1667H14.3333V23.8333ZM14.3333 20.5H12.6667V18.8333H14.3333V20.5ZM14.3333 17.1667H12.6667V15.5H14.3333V17.1667ZM17.6667 20.5H16V18.8333H17.6667V20.5ZM17.6667 17.1667H16V15.5H17.6667V17.1667ZM17.6667 13.8333H16V12.1667H17.6667V13.8333ZM21 20.5H19.3333V18.8333H21V20.5ZM21 17.1667H19.3333V15.5H21V17.1667ZM21 13.8333H19.3333V12.1667H21V13.8333ZM24.3333 23.8333H22.6667V22.1667H24.3333V23.8333ZM24.3333 20.5H22.6667V18.8333H24.3333V20.5Z"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0_5696_10957">
                <rect width="20" height="20" fill="white" transform="translate(8.5 8)" />
            </clipPath>
        </defs>
    </svg>
);

export const ClientsTotalPurchasedIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
        <path
            d="M11.5535 7C11.5535 9.20914 9.81298 11 7.66589 11C5.51881 11 3.77826 9.20914 3.77826 7C3.77826 4.79086 5.51881 3 7.66589 3M11.5535 7C11.5535 4.79086 9.81298 3 7.66589 3M11.5535 7H7.66589V3M9.60971 17V21M17.385 14V21M13.4973 13V21M21.2726 12V21"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);

export const ClientsTotalPaidIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
        <path
            d="M3.77826 3V21H21.2726M10.7371 10.6201L13.0114 13.5001M15.5267 13.3282L18.284 8.74219M11.5535 9C11.5535 10.1046 10.6833 11 9.60971 11C8.53617 11 7.66589 10.1046 7.66589 9C7.66589 7.89543 8.53617 7 9.60971 7C10.6833 7 11.5535 7.89543 11.5535 9ZM21.2726 7C21.2726 8.10457 20.4023 9 19.3288 9C18.2553 9 17.385 8.10457 17.385 7C17.385 5.89543 18.2553 5 19.3288 5C20.4023 5 21.2726 5.89543 21.2726 7ZM16.4131 15C16.4131 16.1046 15.5428 17 14.4693 17C13.3957 17 12.5254 16.1046 12.5254 15C12.5254 13.8954 13.3957 13 14.4693 13C15.5428 13 16.4131 13.8954 16.4131 15Z"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);

export const ClientsTotalDueIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
        <path
            d="M4.75018 20H8.63782V16H12.5255V12H16.4131V8H20.3007M4.75018 11L11.5535 4M11.5535 4V8M11.5535 4H7.66591"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);

export const ClientsAverageM2PriceIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="20" viewBox="0 0 17 20" fill="none">
        <path
            opacity="0.3"
            d="M8.52542 2C5.26953 2 2.69397 4.57 2.69397 8.2C2.69397 10.54 4.58919 13.64 8.52542 17.34C12.4617 13.64 14.3569 10.55 14.3569 8.2C14.3569 4.57 11.7813 2 8.52542 2ZM8.52542 10C7.45632 10 6.5816 9.1 6.5816 8C6.5816 6.9 7.45632 6 8.52542 6C9.59452 6 10.4692 6.9 10.4692 8C10.4692 9.1 9.59452 10 8.52542 10Z"
            fill="white"
        />
        <path
            d="M8.52542 6C7.45632 6 6.58161 6.9 6.58161 8C6.58161 9.1 7.45632 10 8.52542 10C9.59452 10 10.4692 9.1 10.4692 8C10.4692 6.9 9.59452 6 8.52542 6ZM8.52542 0C4.44341 0 0.750153 3.22 0.750153 8.2C0.750153 11.52 3.34515 15.45 8.52542 20C13.7057 15.45 16.3007 11.52 16.3007 8.2C16.3007 3.22 12.6074 0 8.52542 0ZM8.52542 17.33C4.58919 13.63 2.69397 10.54 2.69397 8.19C2.69397 4.57 5.26953 2 8.52542 2C11.7813 2 14.3569 4.57 14.3569 8.2C14.3569 10.54 12.4617 13.64 8.52542 17.33Z"
            fill="white"
        />
    </svg>
);

export const CompanyBuildingIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path opacity="0.3" d="M12 11H14V13H12V15H14V17H12V19H20V9H12V11ZM16 11H18V13H16V11ZM16 15H18V17H16V15Z" fill="#5B4933" />
        <path
            d="M12 7V3H2V21H22V7H12ZM6 19H4V17H6V19ZM6 15H4V13H6V15ZM6 11H4V9H6V11ZM6 7H4V5H6V7ZM10 19H8V17H10V19ZM10 15H8V13H10V15ZM10 11H8V9H10V11ZM10 7H8V5H10V7ZM20 19H12V17H14V15H12V13H14V11H12V9H20V19ZM16 11H18V13H16V11ZM16 15H18V17H16V15Z"
            fill="#5B4933"
        />
    </svg>
);

export const IconSidebarAgentIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" fill="none">
        <path
            opacity="0.3"
            d="M9.25 4C9.25 4.69036 8.69036 5.25 8 5.25C7.30964 5.25 6.75 4.69036 6.75 4C6.75 3.30964 7.30964 2.75 8 2.75C8.69036 2.75 9.25 3.30964 9.25 4Z"
            stroke="#5B4933"
            stroke-width="1.5"
        />
        <path
            opacity="0.3"
            d="M12.3851 13H3.62038C3.84511 12.8925 4.10826 12.7821 4.40341 12.6751C5.45835 12.2925 6.79164 12 8 12C9.20837 12 10.5419 12.2925 11.5975 12.6742C11.8945 12.7816 12.1592 12.8923 12.3851 13Z"
            stroke="#5B4933"
            stroke-width="2"
        />
        <path d="M15.67 9.13C17.04 10.06 18 11.32 18 13V16H22V13C22 10.82 18.43 9.53 15.67 9.13Z" fill="#616161" />
        <path
            d="M14 8C16.21 8 18 6.21 18 4C18 1.79 16.21 0 14 0C13.53 0 13.09 0.0999998 12.67 0.24C13.5 1.27 14 2.58 14 4C14 5.42 13.5 6.73 12.67 7.76C13.09 7.9 13.53 8 14 8Z"
            fill="#616161"
        />
        <path
            d="M8 8C10.21 8 12 6.21 12 4C12 1.79 10.21 0 8 0C5.79 0 4 1.79 4 4C4 6.21 5.79 8 8 8ZM8 2C9.1 2 10 2.9 10 4C10 5.1 9.1 6 8 6C6.9 6 6 5.1 6 4C6 2.9 6.9 2 8 2Z"
            fill="#616161"
        />
        <path
            d="M8 9C5.33 9 0 10.34 0 13V16H16V13C16 10.34 10.67 9 8 9ZM14 14H2V13.01C2.2 12.29 5.3 11 8 11C10.7 11 13.8 12.29 14 13V14Z"
            fill="#616161"
        />
    </svg>
);

export const IconSidebarFiscalIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clip-path="url(#clip0_6125_9222)">
            <path
                opacity="0.3"
                d="M19.25 12C19.25 15.3097 17.0174 18.1106 13.98 18.9749V17.9184C14.6126 17.7279 15.2043 17.4269 15.6797 16.9864C16.3234 16.3901 16.7137 15.573 16.72 14.5647H16.72V14.56C16.72 13.199 16.1156 12.2466 15.255 11.5984C14.4361 10.9817 13.3979 10.6478 12.4986 10.4141L12.4987 10.4141L12.4948 10.4131C11.6309 10.1935 11.1646 9.98694 10.9233 9.80777C10.7371 9.66962 10.72 9.5819 10.72 9.47C10.72 9.31557 10.7804 9.17917 10.9584 9.05472C11.1571 8.91587 11.517 8.79 12.07 8.79C12.6474 8.79 12.9087 8.92995 13.0291 9.04299C13.1465 9.1532 13.2456 9.34661 13.2606 9.7109L13.2903 10.43H14.01H15.72H16.4985L16.4695 9.65203C16.4142 8.17117 15.5857 6.77125 13.98 6.15775V5.02511C17.0174 5.88941 19.25 8.69032 19.25 12ZM10.15 19V19.0106C7.04653 18.1901 4.75 15.3567 4.75 12C4.75 8.64688 7.0416 5.81598 10.14 4.99209V5V6.13139C8.69411 6.62165 7.42 7.73442 7.42 9.51C7.42 10.6539 7.91327 11.5327 8.71912 12.1743C9.48936 12.7875 10.5294 13.1744 11.6521 13.4486L11.652 13.4486L11.6578 13.45C12.5837 13.6684 13.0187 13.9145 13.2193 14.1018C13.3774 14.2495 13.42 14.3857 13.42 14.59C13.42 14.6777 13.3882 14.81 13.2584 14.9273C13.1269 15.0462 12.8046 15.23 12.07 15.23C11.3737 15.23 11.004 15.0727 10.8123 14.9193C10.6339 14.7767 10.5262 14.571 10.4964 14.267L10.4302 13.59H9.75H8.04H7.249L7.29106 14.3799C7.39189 16.2733 8.67868 17.4035 10.15 17.8855V19Z"
                stroke="#5B4933"
                stroke-width="1.5"
            />
            <path
                d="M3 12C3 7.03228 7.03228 3 12 3M3 12C3 16.9677 7.03228 21 12 21M3 12C3 16.9623 7.03772 21 12 21M3 12C3 7.03772 7.03772 3 12 3M12 3C16.9677 3 21 7.03228 21 12M12 3C16.9623 3 21 7.03772 21 12M12 21C16.9677 21 21 16.9677 21 12M12 21C16.9623 21 21 16.9623 21 12M12.24 17.33V18H11.9V17.3V16.9674C11.9594 16.9691 12.0195 16.97 12.08 16.97C12.134 16.97 12.1873 16.9693 12.24 16.9678V17.33ZM11.9 6.69V6H12.23V6.71V7.0425C12.177 7.04082 12.1237 7.04 12.07 7.04C12.0131 7.04 11.9564 7.04091 11.9 7.04276V6.69Z"
                stroke="#5B4933"
                stroke-width="2"
            />
        </g>
        <defs>
            <clipPath id="clip0_6125_9222">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const IconSidebarAgencyIcon = (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Group">
            <path id="Vector" d="M7 13V14V17H5V16V14V13H6H7ZM11 14V13H12H13V14V16V17H11V14Z" stroke="#5B4933" stroke-width="2" />
        </g>
    </svg>
);

export const ClientsEditFormIcon1 = (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <g clip-path="url(#clip0_6235_10765)">
            <path
                opacity="0.3"
                d="M8 7.33333H9.33333V8.66667H8V10H9.33333V11.3333H8V12.6667H13.3333V6H8V7.33333ZM10.6667 7.33333H12V8.66667H10.6667V7.33333ZM10.6667 10H12V11.3333H10.6667V10Z"
                fill="#616161"
            />
            <path
                d="M7.99992 4.66667V2H1.33325V14H14.6666V4.66667H7.99992ZM3.99992 12.6667H2.66659V11.3333H3.99992V12.6667ZM3.99992 10H2.66659V8.66667H3.99992V10ZM3.99992 7.33333H2.66659V6H3.99992V7.33333ZM3.99992 4.66667H2.66659V3.33333H3.99992V4.66667ZM6.66659 12.6667H5.33325V11.3333H6.66659V12.6667ZM6.66659 10H5.33325V8.66667H6.66659V10ZM6.66659 7.33333H5.33325V6H6.66659V7.33333ZM6.66659 4.66667H5.33325V3.33333H6.66659V4.66667ZM13.3333 12.6667H7.99992V11.3333H9.33325V10H7.99992V8.66667H9.33325V7.33333H7.99992V6H13.3333V12.6667ZM10.6666 7.33333H11.9999V8.66667H10.6666V7.33333ZM10.6666 10H11.9999V11.3333H10.6666V10Z"
                fill="#616161"
            />
        </g>
        <defs>
            <clipPath id="clip0_6235_10765">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const ClientsEditFormIcon2 = (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
        <path
            d="M8.53333 8.14666C8.88905 7.83875 9.17437 7.45792 9.36992 7.03001C9.56547 6.6021 9.66667 6.13713 9.66667 5.66666C9.66667 4.78261 9.31548 3.93476 8.69036 3.30964C8.06523 2.68452 7.21739 2.33333 6.33333 2.33333C5.44928 2.33333 4.60143 2.68452 3.97631 3.30964C3.35119 3.93476 3 4.78261 3 5.66666C2.99999 6.13713 3.1012 6.6021 3.29675 7.03001C3.4923 7.45792 3.77762 7.83875 4.13333 8.14666C3.20009 8.56925 2.40831 9.25168 1.85265 10.1124C1.297 10.973 1.00098 11.9755 1 13C1 13.1768 1.07024 13.3464 1.19526 13.4714C1.32029 13.5964 1.48986 13.6667 1.66667 13.6667C1.84348 13.6667 2.01305 13.5964 2.13807 13.4714C2.2631 13.3464 2.33333 13.1768 2.33333 13C2.33333 11.9391 2.75476 10.9217 3.50491 10.1716C4.25505 9.42142 5.27247 8.99999 6.33333 8.99999C7.3942 8.99999 8.41162 9.42142 9.16176 10.1716C9.91191 10.9217 10.3333 11.9391 10.3333 13C10.3333 13.1768 10.4036 13.3464 10.5286 13.4714C10.6536 13.5964 10.8232 13.6667 11 13.6667C11.1768 13.6667 11.3464 13.5964 11.4714 13.4714C11.5964 13.3464 11.6667 13.1768 11.6667 13C11.6657 11.9755 11.3697 10.973 10.814 10.1124C10.2584 9.25168 9.46657 8.56925 8.53333 8.14666V8.14666ZM6.33333 7.66666C5.93777 7.66666 5.55109 7.54936 5.22219 7.3296C4.89329 7.10984 4.63695 6.79748 4.48557 6.43203C4.3342 6.06658 4.29459 5.66444 4.37176 5.27648C4.44893 4.88852 4.63941 4.53215 4.91912 4.25245C5.19882 3.97274 5.55519 3.78226 5.94315 3.70509C6.33111 3.62792 6.73325 3.66753 7.0987 3.8189C7.46415 3.97028 7.77651 4.22662 7.99627 4.55552C8.21604 4.88442 8.33333 5.2711 8.33333 5.66666C8.33333 6.19709 8.12262 6.7058 7.74755 7.08088C7.37247 7.45595 6.86377 7.66666 6.33333 7.66666ZM12.8267 7.87999C13.2533 7.39955 13.532 6.80603 13.6292 6.17089C13.7264 5.53574 13.638 4.88604 13.3745 4.29999C13.1111 3.71395 12.6839 3.21653 12.1443 2.86761C11.6048 2.51869 10.9759 2.33316 10.3333 2.33333C10.1565 2.33333 9.98695 2.40357 9.86193 2.52859C9.7369 2.65361 9.66667 2.82318 9.66667 3C9.66667 3.17681 9.7369 3.34638 9.86193 3.4714C9.98695 3.59642 10.1565 3.66666 10.3333 3.66666C10.8638 3.66666 11.3725 3.87738 11.7475 4.25245C12.1226 4.62752 12.3333 5.13623 12.3333 5.66666C12.3324 6.01682 12.2395 6.3606 12.064 6.66361C11.8886 6.96662 11.6366 7.21825 11.3333 7.39333C11.2345 7.45034 11.1519 7.53177 11.0936 7.62982C11.0352 7.72787 11.003 7.83926 11 7.95333C10.9972 8.0665 11.0233 8.17853 11.0758 8.27883C11.1283 8.37914 11.2054 8.46443 11.3 8.52666L11.56 8.69999L11.6467 8.74666C12.4503 9.12781 13.1282 9.73066 13.6007 10.4842C14.0731 11.2378 14.3204 12.1106 14.3133 13C14.3133 13.1768 14.3836 13.3464 14.5086 13.4714C14.6336 13.5964 14.8032 13.6667 14.98 13.6667C15.1568 13.6667 15.3264 13.5964 15.4514 13.4714C15.5764 13.3464 15.6467 13.1768 15.6467 13C15.6521 11.9769 15.3959 10.9695 14.9023 10.0734C14.4087 9.17724 13.6942 8.4222 12.8267 7.87999V7.87999Z"
            fill="#616161"
        />
    </svg>
);

export const ClientsEditFormIcon3 = (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
        <g clip-path="url(#clip0_6235_10976)">
            <path
                opacity="0.3"
                d="M8.33333 2.66666C5.39333 2.66666 3 5.05999 3 7.99999C3 10.94 5.39333 13.3333 8.33333 13.3333C11.2733 13.3333 13.6667 10.94 13.6667 7.99999C13.6667 5.05999 11.2733 2.66666 8.33333 2.66666ZM9.15333 11.5533V12.6667H7.6V11.54C6.6 11.3333 5.75333 10.6867 5.69333 9.55999H6.83333C6.89333 10.1733 7.31333 10.6533 8.38 10.6533C9.52 10.6533 9.78 10.08 9.78 9.72666C9.78 9.23999 9.52 8.78666 8.22 8.47999C6.77333 8.12666 5.78 7.53332 5.78 6.33999C5.78 5.33332 6.59333 4.68666 7.59333 4.46666V3.33332H9.15333V4.47332C10.24 4.73332 10.78 5.55999 10.8133 6.45332H9.67333C9.64667 5.80666 9.3 5.35999 8.38 5.35999C7.50667 5.35999 6.98 5.75332 6.98 6.31332C6.98 6.79999 7.36 7.12666 8.54 7.42666C9.72 7.73332 10.98 8.23999 10.98 9.70666C10.9733 10.7733 10.1733 11.36 9.15333 11.5533V11.5533Z"
                fill="#616161"
            />
            <path
                d="M8.33317 1.33334C4.65317 1.33334 1.6665 4.32001 1.6665 8.00001C1.6665 11.68 4.65317 14.6667 8.33317 14.6667C12.0132 14.6667 14.9998 11.68 14.9998 8.00001C14.9998 4.32001 12.0132 1.33334 8.33317 1.33334ZM8.33317 13.3333C5.39317 13.3333 2.99984 10.94 2.99984 8.00001C2.99984 5.06001 5.39317 2.66668 8.33317 2.66668C11.2732 2.66668 13.6665 5.06001 13.6665 8.00001C13.6665 10.94 11.2732 13.3333 8.33317 13.3333ZM8.53984 7.42668C7.35984 7.12668 6.97984 6.80001 6.97984 6.31334C6.97984 5.75334 7.5065 5.36001 8.37984 5.36001C9.29984 5.36001 9.6465 5.80001 9.67317 6.45334H10.8132C10.7798 5.56001 10.2332 4.74001 9.15317 4.47334V3.33334H7.59984V4.46001C6.59317 4.67334 5.7865 5.32668 5.7865 6.33334C5.7865 7.52668 6.77984 8.12668 8.2265 8.47334C9.5265 8.78001 9.7865 9.24001 9.7865 9.72001C9.7865 10.0733 9.5265 10.6467 8.3865 10.6467C7.31984 10.6467 6.89984 10.1667 6.83984 9.55334H5.69317C5.75984 10.6867 6.59984 11.3267 7.59984 11.5333V12.6667H9.15984V11.5533C10.1732 11.36 10.9732 10.78 10.9798 9.70668C10.9732 8.24001 9.71317 7.73334 8.53984 7.42668V7.42668Z"
                fill="#616161"
            />
        </g>
        <defs>
            <clipPath id="clip0_6235_10976">
                <rect width="16" height="16" fill="white" transform="translate(0.333252)" />
            </clipPath>
        </defs>
    </svg>
);

export const ClientsEditFormIcon4 = (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
        <path
            d="M3.33325 13.3333H5.99992V10.6667H8.66658V7.99999H11.3333V5.33332H13.9999M3.33325 7.33332L7.99992 2.66666M7.99992 2.66666V5.33332M7.99992 2.66666H5.33325"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);

export const AboutClientsTab = (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clip-path="url(#clip0_6235_10798)">
            <path opacity="0.3" d="M4 12H20V18H4V12ZM4 6H20V8H4V6Z" fill="#616161" />
            <path
                d="M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V12H20V18ZM20 8H4V6H20V8Z"
                fill="#616161"
            />
        </g>
        <defs>
            <clipPath id="clip0_6235_10798">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
export const DocumentEditIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clip-path="url(#clip0_6389_6403)">
            <path opacity="0.3" d="M13 4H6V20H18V9H13V4Z" fill="#616161" />
            <path
                d="M20 8L14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8ZM18 20H6V4H13V9H18V20Z"
                fill="#616161"
            />
        </g>
        <defs>
            <clipPath id="clip0_6389_6403">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const OnlineStatusIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <circle cx="7.25" cy="7" r="6.75" fill="#00C853" />
    </svg>
);

export const PreviousIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clip-path="url(#clip0_6582_5509)">
            <path
                d="M7 8.00098V5.00098L0 12.001L7 19.001V16.001L3 12.001L7 8.00098ZM13 9.00098V5.00098L6 12.001L13 19.001V14.901C18 14.901 21.5 16.501 24 20.001C23 15.001 20 10.001 13 9.00098Z"
                fill="#8B6F4E"
            />
        </g>
        <defs>
            <clipPath id="clip0_6582_5509">
                <rect width="24" height="24" fill="white" transform="translate(0 0.000976562)" />
            </clipPath>
        </defs>
    </svg>
);

export const SendTestIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
        <g clip-path="url(#clip0_6582_2205)">
            <path
                d="M10.5 9.00098V5.00098L3.5 12.001L10.5 19.001V14.901C15.5 14.901 19 16.501 21.5 20.001C20.5 15.001 17.5 10.001 10.5 9.00098Z"
                fill="#8B6F4E"
            />
        </g>
        <defs>
            <clipPath id="clip0_6582_2205">
                <rect width="24" height="24" fill="white" transform="translate(0.5 0.000976562)" />
            </clipPath>
        </defs>
    </svg>
);
